import React, { useCallback, useEffect, useState, useRef, useContext } from 'react';
import {
    ReactFlow,
    Background,
    Controls,
    MiniMap,
    addEdge,
    applyNodeChanges,
    applyEdgeChanges,
    Handle,
    Position,
    BaseEdge,
    EdgeLabelRenderer,
    MarkerType,
    getNodesBounds,
} from "@xyflow/react"
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Dropdown, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { toPng } from 'html-to-image';
import { MdAdd, MdEdit, MdOutlineNotificationsActive, MdOutlineEmail, MdOutlineSms, MdAccessTime, MdOutlineLabel, MdOutlineAltRoute, MdDeleteOutline, MdOutlineFileDownload, MdOutlineAddCircleOutline, MdOutlineRemoveCircleOutline, MdOutlineSaveAlt, MdOutlinePlayCircleOutline, MdOutlineSettings, MdArrowBack, MdOutlinePieChart, MdOutlineBolt, MdOutlineHelpOutline, MdClose, MdKeyboardArrowDown, MdOutlineLocalOffer, MdLockOutline, MdCheck, MdPeopleAlt } from "react-icons/md";
import { BsClockHistory, BsBoxArrowInRight, BsBoxArrowRight, BsChatSquareText, BsWhatsapp, BsThreeDotsVertical } from 'react-icons/bs';
import { LuCopy } from 'react-icons/lu';
import { Utils, fetchWithAuth, fetchAjaxListData, AUTOMATION_NODE_TYPE_CODES, AUTOMATION_WAIT_UNIT_CODES, AUTOMATION_STATUS_CODES, AUTOMATION_EXIT_CONDITION_BITS, AUTOMATION_GOAL_METRIC_CODES, AUTOMATION_MESSAGE_GOAL_METRIC_GROUPS, findOptionByValue, getAutomationNodeType, serializeAutomationGraph, getMarketingUrl, combineLocalDateTime, toLocalIsoDate, toLocalIsoTime, parseLocalIsoDate, subscriptionStatusCodes, templateHeaderFormat, isFileHeaderFormat, headerFileAccept, selectStyles } from '../../utils';
import DateTimePicker from '../common/DateTimePicker/DateTimePicker';
import AsyncSearchSelect from '../common/AsyncSearchSelect';
import Select from 'react-select';
import WhatsAppMessagePreview from '../whatsapp/WhatsAppMessagePreview';
import { useWhatsAppHeaderCheck } from '../../hooks/useWhatsAppHeaderCheck';
import PushNotificationPreview from '../push/PushNotificationPreview';
import { duplicateAutomationAction, deleteAutomationAction, fetchAutomationAuditLogs, createAutomationAction, changeAutomationStatusAction, fetchAutomationNodeCounts, fetchAutomationNodeEnrollments, fetchAutomationSegmentChannelReach } from './AutomationActions';
import AutomationAuditLogsModal from './AutomationAuditLogsModal';
import AutomationNodeUsersModal from './AutomationNodeUsersModal';
import AutomationSetLiveModal from './AutomationSetLiveModal';
import { Drawer, confirmDiscardChanges } from '../common/Drawer'
import SegmentPickerModal from './SegmentPickerModal';
import '@xyflow/react/dist/style.css';

const AutomationBuilderContext = React.createContext(null);

// Do seedhi lines ke beech 90-degree mod ko thoda round kar deta h (chhota quarter-curve) - bilkul
// library ke apne internal smoothstep "bend" helper jesa, bas Condition branch ke custom path ke
// liye yahan khud likha h (kyunki woh wala helper library se export nahi hota).
const CONDITION_BRANCH_RADIUS = 8;
const getConditionBranchBend = (a, b, c, size) => {
    const dist = (p, q) => Math.sqrt((q.x - p.x) ** 2 + (q.y - p.y) ** 2);
    const bendSize = Math.min(dist(a, b) / 2, dist(b, c) / 2, size);
    const { x, y } = b;
    if ((a.x === x && x === c.x) || (a.y === y && y === c.y)) return `L${x} ${y}`;
    if (a.y === y) {
        const xDir = a.x < c.x ? -1 : 1;
        const yDir = a.y < c.y ? 1 : -1;
        return `L ${x + bendSize * xDir},${y}Q ${x},${y} ${x},${y + bendSize * yDir}`;
    }
    const xDir = a.x < c.x ? 1 : -1;
    const yDir = a.y < c.y ? -1 : 1;
    return `L ${x},${y + bendSize * yDir}Q ${x},${y} ${x + bendSize * xDir},${y}`;
};

// Condition -> branch: the line drops this far below the Condition before turning sideways.
const CONDITION_STEM_GAP = 36;
// Where every tail edge turns toward its Join (fixed distance above the Join) - all branches of a
// Condition close at this same Y.
const JOIN_TURN_GAP = 40;

// `points` (kam se kam 2) ko ek smooth step-path (har mod par chhota round bend) me jod deta h -
// buildConditionBranchPath aur buildConditionBranchPathMulti (dono neeche) isi EK helper se apna
// SVG `d` banate h, taaki bend-drawing ka tareeka dono jagah hamesha same rahe.
const pointsToPath = (points) => {
    let path = `M${points[0].x} ${points[0].y}`;
    for (let i = 1; i < points.length - 1; i++) {
        path += getConditionBranchBend(points[i - 1], points[i], points[i + 1], CONDITION_BRANCH_RADIUS);
    }
    path += `L${points[points.length - 1].x} ${points[points.length - 1].y}`;
    return path;
};

const TABS = ['Entry rules', 'Goals', 'Exit rules', 'Re-entry rules', 'Schedule'];

// Exit-condition checkboxes, re-entry/wait unit, aur dono "Goal" metric lists (automation-level +
// message-level) - yeh sab ab commonUtils.mjs se aate h (AUTOMATION_EXIT_CONDITION_BITS,
// AUTOMATION_WAIT_UNIT_CODES, AUTOMATION_GOAL_METRIC_CODES, AUTOMATION_MESSAGE_GOAL_METRIC_GROUPS) taaki
// backend/frontend dono jagah same source-of-truth use ho.

// AUTOMATION_NODE_TYPE_CODES ka order chahe jo bhi ho (commonUtils.mjs me), yahan items ko unke
// `group` ke hisaab se ek sath consolidate kar dete h, taki insert-menu me ek group do baar na dikhe.
const INSERT_MENU_GROUP_ORDER = ['Messages', 'Flow'];

const INSERT_MENU_ITEMS = (() => {
    // in_app / sms: commonUtils.mjs me comment-out hain — yahan extra filter nahi.
    // Entrance/exit canvas pe fixed hain, insert menu me nahi.
    const filtered = AUTOMATION_NODE_TYPE_CODES.filter(item => item.key !== 'entrance' && item.key !== 'exit' && item.key !== 'join');
    const byGroup = {};
    filtered.forEach((item) => {
        if (!byGroup[item.group]) byGroup[item.group] = [];
        byGroup[item.group].push(item);
    });
    // Explicit order (Messages pehle, Flow baad me) - AUTOMATION_NODE_TYPE_CODES me item kahi bhi ho,
    // yahan display order isi list se decide hota h.
    const knownGroups = INSERT_MENU_GROUP_ORDER.filter((g) => byGroup[g]);
    const remainingGroups = Object.keys(byGroup).filter((g) => !INSERT_MENU_GROUP_ORDER.includes(g));
    return [...knownGroups, ...remainingGroups].flatMap((group) => byGroup[group]);
})();

const NodeActionsMenu = ({ id, fullActions = true }) => {
    const { onEditNode, onDuplicateNode, onRemoveNode, openActionsMenuId, setOpenActionsMenuId, readOnly } = useContext(AutomationBuilderContext);
    const show = openActionsMenuId === id;
    const setShow = (isOpen) => setOpenActionsMenuId?.(isOpen ? id : null);

    return (
        // Plain wrapper div (bootstrap ki ".dropdown" class ke upar position:absolute lagane se
        // cascade order ka masla ho raha tha - bootstrap.min.css App.css ke BAAD load hota h
        // (src/index.js me), isliye ".dropdown{position:relative}" humari ".node-actions-menu"
        // wali position:absolute ko override kar raha tha. Ab positioning is neutral wrapper pe h,
        // andar ka <Dropdown> apni normal "dropdown" class ke sath untouched rehta h.
        // "show"/"openActionsMenuId" parent (AutomationBuilder) me lifted h taki jab menu khula ho
        // tab us node ko zIndex se upar uthaya ja sake (warna dropdown kisi dusre/selected card
        // ke peeche chhup sakta h, kyuki React Flow har node ka apna stacking context banata h).
        <div className="node-actions-menu" onClick={(e) => e.stopPropagation()}>
            <Dropdown
                show={show}
                onToggle={(isOpen) => setShow(isOpen)}
            >
                <Dropdown.Toggle
                    as="button"
                    type="button"
                    bsPrefix="node-actions-toggle"
                    title="More options"
                >
                    <BsThreeDotsVertical size={14} />
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu-subscription node-actions-dropdown-menu" align="end">
                <Dropdown.Item as="button" type="button" onClick={(e) => { e.stopPropagation(); setShow(false); onEditNode?.(id); }}>
                    <MdEdit />
                    <span>{readOnly ? 'View details' : 'Edit'}</span>
                </Dropdown.Item>
                {fullActions && !readOnly && (
                    <>
                        <Dropdown.Item as="button" type="button" onClick={(e) => { e.stopPropagation(); setShow(false); onDuplicateNode?.(id); }}>
                            <LuCopy />
                            <span>Duplicate</span>
                        </Dropdown.Item>
                        <Dropdown.Item as="button" type="button" className="delete-class" onClick={(e) => { e.stopPropagation(); setShow(false); onRemoveNode?.(id); }}>
                            <MdDeleteOutline />
                            <span>Delete</span>
                        </Dropdown.Item>
                    </>
                )}
            </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

// Live "kitne user abhi is card pe h" badge - nodeCounts aata h ek baar automation-level fetch se
// (AutomationBuilderContext me), yahan sirf is node ki apni ginti dikhti h. Count pe click karne
// se (uske neeche) exact user list khulti h - taaki "konsa user kahan ruka h" bina DB khole
// pata chal sake. Entrance/Exit pe nahi dikhti (wahan "waiting" ka concept nahi hota).
const NodeUserCountBadge = ({ id, label }) => {
    const { nodeCounts, onViewNodeUsers } = useContext(AutomationBuilderContext);
    const entry = nodeCounts?.[id];
    const total = entry?.total || 0;
    const failed = entry?.failed || 0;
    if (!total) return null;
    return (
        <span className="automation-node-user-count-wrap">
            <button
                type="button"
                className="automation-node-user-count-badge"
                title={`${total} user${total === 1 ? '' : 's'} currently here - click to see who`}
                onClick={(e) => { e.stopPropagation(); onViewNodeUsers?.(id, label); }}
            >
                <MdPeopleAlt size={12} />
                <span>{total}</span>
            </button>
            {failed ? (
                <button
                    type="button"
                    className="automation-node-user-error-badge"
                    title={`${failed} user${failed === 1 ? '' : 's'} failed here - click to see who`}
                    onClick={(e) => { e.stopPropagation(); onViewNodeUsers?.(id, label); }}
                >
                    <MdClose size={11} />
                    <span>{failed}</span>
                </button>
            ) : null}
        </span>
    );
};

// Drag ke dauran dragged card ki ORIGINAL jagah pe iska ek clone dikhta h - bilkul asli
// card jesa (same icon/title/body), taki jagah khaali dashed box jesi na lage. Isi node pe
// edges bhi (temporarily) reroute ho jati h, taki upar-niche ke arrow/plus bilkul normal
// connected dikhte rahe - jab tak drop nahi ho jata. Asli (drag ho raha) node iske bina
// free-float karta h, isliye uski taraf koi line kheenchti hui nahi dikhti.
const DragGhostNode = ({ data }) => {
    const typeInfo = AUTOMATION_NODE_TYPE_CODES.find(item => item.value === data?.nodeType);
    const Icon = typeInfo?.icon;
    const isCondition = data?.nodeType === getAutomationNodeType('condition')?.value;

    return (
        <div className="automation-node automation-drag-ghost" style={{ width: data?.width, height: data?.height }}>
            <Handle type="target" position={Position.Top} />
            <div className="automation-node-header">
                {Icon && <div className="automation-node-icon"><Icon size={14} /></div>}
                <strong>{typeInfo?.label}</strong>
            </div>
            <div className="automation-node-body">
                <div>{data?.nodeData?.label || data?.nodeData?.template || ''}</div>
            </div>
            {isCondition ? (
                <>
                    <Handle type="source" position={Position.Bottom} id="yes" style={{ left: '35%' }} />
                    <Handle type="source" position={Position.Bottom} id="no" style={{ left: '70%' }} />
                </>
            ) : (
                <Handle type="source" position={Position.Bottom} />
            )}
        </div>
    );
};

const EntranceNode = ({ id, data }) => (
    <div className='automation-node entrance-node'>
        <Handle type='source' position={Position.Bottom} />
        <div className="automation-node-header">
            <div className="automation-node-icon"><BsBoxArrowInRight size={14} color="var(--primary-color)" /></div>
            <strong>{getAutomationNodeType('entrance')?.label}</strong>
        </div>
        <div className="automation-node-body">
            <div>{data?.label || 'Automation Start'}</div>
        </div>
        <NodeActionsMenu id={id} fullActions={false} />
    </div>
)

const WaitNode = ({ id, data }) => {

    return (
        <div className='automation-node wait-node'>
            <Handle type='target' position={Position.Top} />
            <Handle type='source' position={Position.Bottom} />
            <div className="automation-node-header">
                <div className="automation-node-icon"><MdAccessTime size={14} /></div>
                <strong>{getAutomationNodeType('wait')?.label}</strong>
            </div>
            <div className="automation-node-body automation-node-body-row">
                <div>{data?.delay || '0'} {findOptionByValue(AUTOMATION_WAIT_UNIT_CODES, data?.unit)?.label || 'minutes'}</div>
                <NodeUserCountBadge id={id} label={getAutomationNodeType('wait')?.label} />
            </div>
            <NodeActionsMenu id={id} />
        </div>
    )
}

const PushNotification = ({ id, data }) => {

    return (
        <div className='automation-node send-node'>
            <Handle type='target' position={Position.Top} />
            <Handle type='source' position={Position.Bottom} />
            <div className="automation-node-header">
                <div className="automation-node-icon"><MdOutlineNotificationsActive size={14} /></div>
                <strong>{getAutomationNodeType('push')?.label}</strong>
            </div>
            <div className="automation-node-body automation-node-body-row">
                <small>{data?.template || 'Template not selected'}</small>
                <NodeUserCountBadge id={id} label={getAutomationNodeType('push')?.label} />
            </div>
            <NodeActionsMenu id={id} />
        </div>
    )
}

const ConditionNode = ({ id, data }) => {

    return (
        <div className='automation-node condition-node'>
            <Handle type='target' position={Position.Top} />

            <div className="automation-node-header">
                <div className="automation-node-icon"><MdOutlineAltRoute size={14} /></div>
                <strong>{getAutomationNodeType('condition')?.label}</strong>
            </div>

            <div className="automation-node-body automation-node-body-row">
                <div>
                    {(() => {
                        const mode = data?.conditionMode || 'message';
                        if (mode === 'event') return data?.eventName ? `Performed event: ${data.eventName}` : 'Choose the event this branch checks';
                        if (mode === 'segment') {
                            return Array.isArray(data?.segmentIds) && data.segmentIds.length > 0
                                ? `In segment: ${data.segmentIds.map((s) => s.name).join(', ')}`
                                : 'Choose the segment this branch checks';
                        }
                        return data?.messageBehaviorLabel || 'Set up the message this branch checks';
                    })()}
                </div>
                <NodeUserCountBadge id={id} label={getAutomationNodeType('condition')?.label} />
            </div>

            {/* Pehle Yes/No ke liye do alag Handles the (card ke bottom pe do dots dikhte the) -
                ab sirf EK hi Handle h (center se ek hi line niche jaati h), Yes/No branches
                dono isi EK point se nikalti h aur edges khud apne-apne target ki taraf diverge
                hoke alag "+" per pahunch jaati h (computeLayout already is tarah x-spread
                karta h) - "yes"/"no" ab Handle id nahi, balki edge.data.branch me store hota h.
                "Yes"/"No" label yahan NODE ke static child ki tarah nahi (wo hamesha center ke
                paas hi chipka reh jaata, chahe branch kitna bhi left/right split ho) - ab PlusEdge
                khud apne turn-point par render karta h, taaki label hamesha wahi dikhe jahan
                line asal me left/right move karke niche turn hoti h. */}
            <Handle
                type="source"
                position={Position.Bottom}
                id="out"
            />
            <NodeActionsMenu id={id} />
        </div>
    )
}
const ExitNode = ({ id, data }) => (
    <div className='automation-node exit-node'>
        <Handle type='target' position={Position.Top} />
        <div className="automation-node-header">
            <div className="automation-node-icon"><BsBoxArrowRight size={14} /></div>
            <strong>{getAutomationNodeType('exit')?.label}</strong>
        </div>
        <div className="automation-node-body automation-node-body-row">
            <div>{data?.label || 'Automation End'}</div>
            {/* Enrollments that actually complete the Automation (walk through this real Exit node,
                not a dead-end with no outgoing edge) get current_node_id set to this node's id by
                processEnrollment - see automation.service.js. So this is the running completed-count
                for the Automation, same badge component used on every other node. */}
            <NodeUserCountBadge id={id} label={getAutomationNodeType('exit')?.label} />
        </div>
        <NodeActionsMenu id={id} fullActions={false} />
    </div>
)

const EmailNode = ({ id, data }) => {
    return (
        <div className='automation-node email-node'>
            <Handle type='target' position={Position.Top} />
            <Handle type='source' position={Position.Bottom} />
            <div className="automation-node-header">
                <div className="automation-node-icon"><MdOutlineEmail size={14} /></div>
                <strong>{getAutomationNodeType('email')?.label}</strong>
            </div>
            <div className="automation-node-body automation-node-body-row">
                <div>{data?.template || 'Template not selected'}</div>
                <NodeUserCountBadge id={id} label={getAutomationNodeType('email')?.label} />
            </div>
            <NodeActionsMenu id={id} />
        </div>
    )
}

const InAppNode = ({ id, data }) => {
    return (
        <div className='automation-node in-app-node'>
            <Handle type='target' position={Position.Top} />
            <Handle type='source' position={Position.Bottom} />
            <div className="automation-node-header">
                <div className="automation-node-icon"><BsChatSquareText size={14} /></div>
                <strong>{getAutomationNodeType('in_app')?.label}</strong>
            </div>
            <div className="automation-node-body automation-node-body-row">
                <div>{data?.template || 'Template not selected'}</div>
                <NodeUserCountBadge id={id} label={getAutomationNodeType('in_app')?.label} />
            </div>

            <NodeActionsMenu id={id} />
        </div>
    )
}


const SmsNode = ({ id, data }) => {
    return (
        <div className='automation-node sms-node'>
            <Handle type='target' position={Position.Top} />
            <Handle type='source' position={Position.Bottom} />
            <div className="automation-node-header">
                <div className="automation-node-icon"><MdOutlineSms size={14} /></div>
                <strong>{getAutomationNodeType('sms')?.label}</strong>
            </div>
            <div className="automation-node-body automation-node-body-row">
                <div>{data?.template || 'Template not selected'}</div>
                <NodeUserCountBadge id={id} label={getAutomationNodeType('sms')?.label} />
            </div>
            <NodeActionsMenu id={id} />
        </div>
    )
}

const TagNode = ({ id, data }) => {
    const tagLabel = (Array.isArray(data?.tags) ? data.tags : [])
        .filter((t) => String(t?.key || '').trim() || String(t?.value || '').trim())
        .map((t) => [t.key, t.value].map((part) => String(part || '').trim()).filter(Boolean).join(': '))
        .join(', ');
    return (
        <div className='automation-node tag-node'>
            <Handle type='target' position={Position.Top} />
            <Handle type='source' position={Position.Bottom} />
            <div className="automation-node-header">
                <div className="automation-node-icon"><MdOutlineLabel size={14} /></div>
                <strong>{getAutomationNodeType('tag')?.label}</strong>
            </div>
            <div className="automation-node-body automation-node-body-row">
                <div>{tagLabel || 'No tag added'}</div>
                <NodeUserCountBadge id={id} label={getAutomationNodeType('tag')?.label} />
            </div>
            <NodeActionsMenu id={id} />
        </div>
    )
}

const WhatsAppNode = ({ id, data }) => {
    return (
        <div className='automation-node whatsapp-node'>
            <Handle type='target' position={Position.Top} />
            <Handle type='source' position={Position.Bottom} />
            <div className="automation-node-header">
                <div className="automation-node-icon"><BsWhatsapp size={14} /></div>
                <strong>{getAutomationNodeType('whatsapp')?.label}</strong>
            </div>
            <div className="automation-node-body automation-node-body-row">
                <div>{data?.template || 'Template not selected'}</div>
                <NodeUserCountBadge id={id} label={getAutomationNodeType('whatsapp')?.label} />
            </div>
            <NodeActionsMenu id={id} />
        </div>
    )
}
// Automation canvas edge. Every Condition block is explicit in the graph: Condition --yes/no-->
// (branch nodes...) --> Join (an invisible merge-point node) --> rest of the flow. So each edge
// is one of four simple shapes, decided by the parent from the graph (data.edgeKind):
//   "branch"      Condition -> first node of a branch: down a short stem, sideways to the
//                 branch column, straight down to the node.
//   "branchEmpty" Condition -> its Join directly (empty branch): stem, sideways to the branch
//                 column, down to the shared merge turn, back to the centre, into the Join.
//   "tail"        last node of a branch (or a nested block's Join) -> the Join: straight down
//                 to the shared merge turn, sideways to the centre, into the Join.
//   "plain"       everything else: straight down (step if columns differ).
// Every tail into the same Join turns at the same Y (Join's top - JOIN_TURN_GAP), so both sides of
// a Condition always close at the same height no matter how long/short or nested each side is.
const PlusEdge = ({ id, sourceX, sourceY, targetX, targetY, data, markerEnd }) => {
    const { insertMenu, insertMenuRef, onSelectType } = useContext(AutomationBuilderContext);
    const kind = data?.edgeKind || 'plain';
    const stemY = sourceY + CONDITION_STEM_GAP;
    const turnY = targetY - JOIN_TURN_GAP;
    const branchX = data?.branchX != null ? data.branchX : targetX;
    let points;
    let plusX;
    let plusY;
    let branchLabel = null;
    if (kind === 'branch') {
        points = [{ x: sourceX, y: sourceY }, { x: sourceX, y: stemY }, { x: targetX, y: stemY }, { x: targetX, y: targetY }];
        plusX = targetX;
        plusY = (stemY + targetY) / 2;
    } else if (kind === 'branchEmpty') {
        const t = Math.max(turnY, stemY + 20);
        points = [
            { x: sourceX, y: sourceY }, { x: sourceX, y: stemY }, { x: branchX, y: stemY },
            { x: branchX, y: t }, { x: targetX, y: t }, { x: targetX, y: targetY },
        ];
        plusX = branchX;
        plusY = (stemY + t) / 2;
    } else if (kind === 'tail') {
        const t = Math.max(turnY, sourceY + 10);
        points = [{ x: sourceX, y: sourceY }, { x: sourceX, y: t }, { x: targetX, y: t }, { x: targetX, y: targetY }];
        plusX = sourceX;
        plusY = (sourceY + t) / 2;
    } else {
        const midY = (sourceY + targetY) / 2;
        points = Math.abs(sourceX - targetX) < 1
            ? [{ x: sourceX, y: sourceY }, { x: targetX, y: targetY }]
            : [{ x: sourceX, y: sourceY }, { x: sourceX, y: midY }, { x: targetX, y: midY }, { x: targetX, y: targetY }];
        plusX = targetX;
        plusY = midY;
    }
    if ((kind === 'branch' || kind === 'branchEmpty') && (data?.branch === 'yes' || data?.branch === 'no')) {
        const lx = kind === 'branch' ? targetX : branchX;
        branchLabel = { x: lx, y: stemY - 12, text: data.branch === 'yes' ? 'Yes' : 'No' };
    }
    const edgePath = pointsToPath(points);
    const isMenuOpen = insertMenu?.edgeId === id;
    const isDropTarget = data?.dropTargetId === id;
    const dragInProgress = !!data?.dragInProgress;

    return (
        <>
            <BaseEdge
                id={id}
                path={edgePath}
                markerEnd={data?.intoJoin ? undefined : markerEnd}
                style={{ stroke: isDropTarget ? 'var(--primary-color, #6366f1)' : '#9ca3af', strokeWidth: isDropTarget ? 2.5 : 1.5 }}
            />
            <EdgeLabelRenderer>
                {dragInProgress && (
                    <div
                        className={`automation-edge-drop-zone${isDropTarget ? ' active' : ''}`}
                        data-plus-id={id}
                        style={{ position: 'absolute', transform: `translate(-50%, -50%) translate(${plusX}px, ${plusY}px)` }}
                    />
                )}
                {branchLabel && (
                    <div
                        className="automation-edge-branch-label"
                        style={{ position: 'absolute', transform: `translate(-50%, -50%) translate(${branchLabel.x}px, ${branchLabel.y}px)` }}
                    >
                        {branchLabel.text}
                    </div>
                )}
                {!data?.readOnly && (
                    <button
                        className={`automation-edge-plus-btn${isDropTarget ? ' drop-target-active' : ''}`}
                        style={{ position: 'absolute', transform: `translate(-50%, -50%) translate(${plusX}px, ${plusY}px)`, pointerEvents: 'all' }}
                        onClick={(e) => { e.stopPropagation(); data?.onAdd?.(id); }}
                    >
                        <MdAdd />
                    </button>
                )}
                {isMenuOpen && (!insertMenu.step || insertMenu.step === 'list') && (
                    <div
                        className="automation-insert-menu"
                        ref={insertMenuRef}
                        style={{ transform: `translate(20px, -16px) translate(${plusX}px, ${plusY}px)` }}
                    >
                        <InsertMenuList onSelect={onSelectType} />
                    </div>
                )}
            </EdgeLabelRenderer>
        </>
    );
};

// Invisible merge point of a Condition block - only exists so every branch has one explicit
// place to close at (see PlusEdge above). No card, no menu, not clickable or draggable.
const JoinNode = () => (
    <div className="automation-join-node">
        <Handle type="target" position={Position.Top} />
        <Handle type="source" position={Position.Bottom} />
    </div>
);

// App ke standard "More options" / card ke 3-dot / Automations-list row-actions dropdown jesa hi
// (Dropdown + Dropdown.Menu className="dropdown-menu-subscription") - Metric/Template/Wait-unit
// jese "select a value" dropdowns bhi ab isi shared component se bante h, taaki poore app me
// dropdown ek hi tarah ka ho (bilkul same), alag se custom markup na likhna pade har jagah.
// `options` flat list ke liye, `groups` (Metric jesa grouped) ke liye - dono me se ek hi pass
// karna h. `footer` optional extra row (jese "Add custom conversion") ke liye h.
const SelectDropdown = ({ value, options, groups, placeholder, onSelect, loading, emptyText, footer, wrapClassName, wrapStyle }) => {
    const [show, setShow] = useState(false);
    const flatOptions = groups ? groups.flatMap((g) => g.options) : (options || []);
    const selected = flatOptions.find((o) => String(o.value) === String(value));

    const renderOption = (o) => {
        const isSelected = String(value) === String(o.value);
        return (
            <Dropdown.Item
                as="button"
                type="button"
                key={o.value}
                disabled={!!o.locked}
                className={isSelected ? 'active' : ''}
                onClick={() => { onSelect(o.value); setShow(false); }}
            >
                <span>{o.label}</span>
                {o.locked
                    ? <MdLockOutline size={14} className="automation-settings-select-lock" />
                    : (isSelected && <MdCheck size={16} className="automation-settings-select-check" />)}
            </Dropdown.Item>
        );
    };

    return (
        <Dropdown
            className={`automation-settings-select-wrap ${wrapClassName || ''}`}
            style={wrapStyle}
            show={show}
            onToggle={setShow}
        >
            <Dropdown.Toggle as="button" type="button" bsPrefix="automation-settings-select-trigger">
                <span className={selected ? '' : 'automation-settings-select-placeholder'}>
                    {selected ? selected.label : (loading ? 'Loading...' : (placeholder || 'Select...'))}
                </span>
                <MdKeyboardArrowDown size={18} />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-subscription automation-settings-select-dropdown-menu">
                {groups
                    ? groups.map((g) => (
                        <React.Fragment key={g.group}>
                            <div className="automation-settings-select-group-title">{g.group}</div>
                            {g.options.map(renderOption)}
                        </React.Fragment>
                    ))
                    : (flatOptions.length === 0 && !loading
                        ? <div className="automation-settings-select-empty">{emptyText || 'No options'}</div>
                        : flatOptions.map(renderOption))
                }
                {footer}
            </Dropdown.Menu>
        </Dropdown>
    );
};

// WhatsApp template ke liye "Send Test" modal - koi existing reusable modal nahi tha (jaisa
// Push Notification ke "Send Test Push" ka already bana hua h), isliye yeh naya, chhota modal:
// sirf ek WhatsApp number leta h aur application/whatsapp/send-test ko hit karta h.
const SendTestWhatsAppModal = ({ show, onClose, appId, templateName, languageCode, bodyParameters, headerMedia }) => {
    const [to, setTo] = useState('');
    const [sending, setSending] = useState(false);

    const handleSend = async () => {
        if (!to.trim()) {
            toast.error('Please enter a WhatsApp number (with country code)');
            return;
        }
        setSending(true);
        try {
            const res = await fetchWithAuth(Utils.baseurl + 'application/whatsapp/send-test', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    app_id: appId,
                    to: to.trim(),
                    templateName,
                    languageCode,
                    body_parameters: bodyParameters,
                    ...(headerMedia || {}),
                }),
            });
            const result = await res.json().catch(() => ({}));
            if (result.status) {
                toast.success('Test message sent');
                onClose();
            } else {
                toast.error(result.message || 'Failed to send test message');
            }
        } catch (e) {
            toast.error('Failed to send test message');
        } finally {
            setSending(false);
        }
    };

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Send Test Message</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <label className="automation-settings-field-label">WhatsApp number (with country code)</label>
                <input
                    type="text"
                    className="form-control"
                    placeholder="e.g. 919876543210"
                    value={to}
                    onChange={(e) => setTo(e.target.value)}
                    autoFocus
                />
                <p className="automation-settings-help-text mt-2">
                    Template: <strong>{templateName || '-'}</strong>{languageCode ? ` (${languageCode})` : ''}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="add_app_btn_secondary btn_theme_secondary" onClick={onClose}><span>Cancel</span></button>
                <button type="button" className="add_app_btn btn_theme_primary" onClick={handleSend} disabled={sending}>
                    <span>{sending ? 'Sending…' : 'Send'}</span>
                </button>
            </Modal.Footer>
        </Modal>
    );
};

// Push Notification template ke liye "Send Test Push" - PushNotification.js (compose page) ke
// already bane hue "Send Test Push" modal jaisa hi (search + checkbox + Name/Mobile/Subscription
// ID table), bas yahan selected TEMPLATE ke data se bheja jata h (compose-page ke local state ki
// jagah). Backend same `notification/send` endpoint hit karta h jo woh modal use karta h.
const SendTestPushAutomationModal = ({ show, onClose, appId, template }) => {
    const [subs, setSubs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [selected, setSelected] = useState([]);
    const [sending, setSending] = useState(false);

    useEffect(() => {
        if (!show || !appId) return;
        let cancelled = false;
        setLoading(true);
        const { subscribed } = subscriptionStatusCodes();
        fetchWithAuth(Utils.baseurl + 'get/app/subscriptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ appId, isTest: 1, status: subscribed }),
        })
            .then((res) => res.json())
            .then((result) => {
                if (!cancelled) setSubs(result?.data?.appSubscriptionData || []);
            })
            .catch(() => { if (!cancelled) setSubs([]); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [show, appId]);

    const filtered = subs.filter((s) => !search.trim() || String(s.name || '').toLowerCase().includes(search.trim().toLowerCase()));
    const toggle = (id) => setSelected((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));

    const handleSend = async () => {
        if (!selected.length) {
            toast.error('Please select at least one test subscriber');
            return;
        }
        setSending(true);
        try {
            const res = await fetchWithAuth(Utils.baseurl + 'notification/send', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    appId,
                    title: template?.title,
                    message: template?.message,
                    image: template?.image,
                    largeIcon: template?.largeIcon,
                    smallIcon: template?.smallIcon,
                    sound: template?.sound,
                    lockscreenVisibility: template?.lockscreenVisibility,
                    priority: template?.priority,
                    timeToLive: template?.timeToLive,
                    timeUnit: template?.timeUnit,
                    keyValuePairs: template?.keyValuePairs,
                    actionButtons: template?.actionButtons,
                    subscriptionIds: selected,
                    audience_type: 3,
                }),
            });
            const result = await res.json().catch(() => ({}));
            if (result.success) {
                toast.success(result.message || `Test push sent to ${selected.length} user(s)`);
                onClose();
            } else {
                toast.error(result.message || 'Failed to send test push');
            }
        } catch (e) {
            toast.error('Failed to send test push');
        } finally {
            setSending(false);
        }
    };

    return (
        <Modal show={show} onHide={onClose} className="modal-lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Send Test Push</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <input
                    type="text"
                    className="form-control mb-3"
                    placeholder="Search by name"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
                {loading ? (
                    <p className="text-muted">Loading test subscribers…</p>
                ) : (
                    <table className="table table-striped table-bordered text-center">
                        <thead>
                            <tr>
                                <th>Select</th>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Subscription ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.length === 0 && (
                                <tr><td colSpan={4} className="text-muted">No test subscribers found</td></tr>
                            )}
                            {filtered.map((sub, index) => (
                                <tr key={sub.subscription_id || index}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selected.includes(sub.subscription_id)}
                                            onChange={() => toggle(sub.subscription_id)}
                                        />
                                    </td>
                                    <td>{sub.name}</td>
                                    <td>{sub.mobile}</td>
                                    <td>{sub.subscription_id}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="add_app_btn_secondary btn_theme_secondary" onClick={onClose}><span>Cancel</span></button>
                <button type="button" className="add_app_btn btn_theme_primary" onClick={handleSend} disabled={sending}>
                    <span>{sending ? 'Sending…' : 'Send'}</span>
                </button>
            </Modal.Footer>
        </Modal>
    );
};

const getNodeConfigTitle = (nodeType) => {
    if (nodeType === getAutomationNodeType('wait')?.value) return 'Wait';
    if (nodeType === getAutomationNodeType('push')?.value) return 'Send push notification';
    if (nodeType === getAutomationNodeType('email')?.value) return 'Send Email';
    if (nodeType === getAutomationNodeType('tag')?.value) return 'Add User';
    if (nodeType === getAutomationNodeType('whatsapp')?.value) return 'Send WhatsApp message';
    if (nodeType === getAutomationNodeType('condition')?.value) return 'Yes/No Branch';
    return `${getAutomationNodeType(nodeType, 'value')?.label || ''} Configuration`;
};

// Wait / Send Email / Send push notification / Add User (tag) / Send WhatsApp message node ke
// config-drawer fields - NodeConfigPanel (existing node edit) aur insertMenu "configure" step
// (naya node insert) dono yahi ek component reuse karte h, taaki fields do jagah copy-paste na
// karne pade. appId sirf WhatsApp templates list fetch karne ke liye chahiye.
// Custom event names are stored lowercase with underscores (same convention the SDK sends
// event_type in, and what Exit Rules / entry matching compare against).
const normalizeEventName = (s) => String(s || '').trim().toLowerCase().replace(/\s+/g, '_');

// One shared "pick an existing event or type a new one" dropdown - events already seen for this
// app come from the shared /ajax-list "app-event-metrics" source (same picker the Metric Events
// setting uses); anything not in the list can still be typed and used as-is.
const EventNameSelect = ({ appId, value, onChange, inputId, placeholder = 'Select or type an event name…' }) => {
    const fetchOptions = useCallback(async ({ search, ids }) => {
        if (!appId) return [];
        return fetchAjaxListData({ type: 'app-event-metrics', q: search, id: ids, extra: { app_id: appId }, mode: 'options' });
    }, [appId]);
    return (
        <AsyncSearchSelect
            inputId={inputId}
            instanceId={inputId}
            creatable
            placeholder={placeholder}
            fetchOptions={fetchOptions}
            value={value || null}
            onChange={(opt) => onChange(opt ? normalizeEventName(opt.value ?? opt.label) : '')}
            formatCreateLabel={(input) => `Use "${normalizeEventName(input)}"`}
            isValidNewOption={(input) => Boolean(normalizeEventName(input))}
        />
    );
};

const NodeConfigFields = ({ nodeType, draft, update, appId, allNodes }) => {
    const [showSenderBanner, setShowSenderBanner] = useState(true);
    const [showAdvanced, setShowAdvanced] = useState(false);
    const [showSegmentModal, setShowSegmentModal] = useState(false);
    // Dropdown ke "raw" row (preview/variable-count ke liye poora template object chahiye,
    // sirf {value,label} nahi) - AsyncSearchSelect apna cache andar hi rakhta h, isliye jab
    // bhi selected id badle, usi id ke liye yeh row khud fetch karke yahan rakh lete h.
    const [selectedWaTemplateRaw, setSelectedWaTemplateRaw] = useState(null);
    const [selectedPushTemplateRaw, setSelectedPushTemplateRaw] = useState(null);
    const [showWaSendTestModal, setShowWaSendTestModal] = useState(false);
    const [showPushSendTestModal, setShowPushSendTestModal] = useState(false);
    // Header media (image/video/document) file picked for upload - not stored on the node
    // itself; uploading swaps it for a header_image_id on draft (same pattern as
    // WhatsAppSettings.js's bulk-send header upload), which IS what gets saved on the node.
    const [waHeaderFile, setWaHeaderFile] = useState(null);
    const [waHeaderUploading, setWaHeaderUploading] = useState(false);
    const [waHeaderFilePreview, setWaHeaderFilePreview] = useState('');
    useEffect(() => {
        if (!waHeaderFile) { setWaHeaderFilePreview(''); return undefined; }
        const url = URL.createObjectURL(waHeaderFile);
        setWaHeaderFilePreview(url);
        return () => URL.revokeObjectURL(url);
    }, [waHeaderFile]);
    const waHeaderCheck = useWhatsAppHeaderCheck({
        appId,
        template: selectedWaTemplateRaw,
        skip: Boolean(waHeaderFile || draft?.header_image_id || String(draft?.header_image_url || '').trim()),
    });

    const WAIT_TYPE = getAutomationNodeType('wait')?.value;
    const PUSH_TYPE = getAutomationNodeType('push')?.value;
    const EMAIL_TYPE = getAutomationNodeType('email')?.value;
    const TAG_TYPE = getAutomationNodeType('tag')?.value;
    const WHATSAPP_TYPE = getAutomationNodeType('whatsapp')?.value;
    const CONDITION_TYPE = getAutomationNodeType('condition')?.value;

    // select2-style AJAX dropdown (AsyncSearchSelect, jaisa app ke dusre modules - Support
    // Groups, Applications filter, etc. - me already use hota h) ke liye fetchOptions: jab user
    // type kare to backend se "%search%" ke hisaab se naye results aate h; Authentication/OTP
    // templates ko Automation flow me kabhi na dikhane ke liye exclude_category hamesha bhejte h
    // (point 2: "flow me abhi authentication wale ke alava wale template ayenge"). Jab kisi
    // specific id ko resolve karna ho (pehle se saved node open karte waqt, ya preview ke liye
    // neeche wala useEffect), tab limit hata dete h taaki slice se woh id miss na ho jaye.
    // "whatsapp-templates" ajax-list case (backend/utils/customUtils.js) reads the local
    // whatsapp_templates mirror - same reusable dropdown source pattern as the Push templates
    // dropdown, and properly supports server-side `ids` lookup (the old dedicated-endpoint
    // version had to over-fetch and filter client-side for that).
    const fetchWaTemplateOptions = useCallback(async ({ search, ids }) => {
        if (!appId) return [];
        const rows = await fetchAjaxListData({
            type: 'whatsapp-templates',
            q: search,
            id: ids,
            extra: { app_id: appId, exclude_category: 'AUTHENTICATION' },
            mode: 'rows',
        });
        return rows.map((t) => ({ value: String(t.id), label: `${t.text} (${t.language || 'default'})`, raw: t }));
    }, [appId]);

    useEffect(() => {
        if (nodeType !== WHATSAPP_TYPE || !draft?.template_id) { setSelectedWaTemplateRaw(null); return; }
        let cancelled = false;
        fetchWaTemplateOptions({ search: '', ids: [String(draft.template_id)] }).then((opts) => {
            if (cancelled) return;
            const raw = opts[0]?.raw || null;
            setSelectedWaTemplateRaw(raw);
            const name = raw?.text || '';
            if (name && name !== draft.template) update('template', name);
        }).catch(() => { if (!cancelled) setSelectedWaTemplateRaw(null); });
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nodeType, draft?.template_id, appId]);

    // Push Notification templates (point 4) - naye backend endpoint (application/push/templates/list)
    // se, same select2-style pattern. Push templates khud-ke app me hi save hote h (Meta jaisa
    // koi external source nahi), isliye exclude_category jaisi koi filtering chahiye nahi.
    // "notification-templates" ajax-list case (backend/utils/customUtils.js) is the same
    // select2-style dropdown source the Templates list page could reuse elsewhere later -
    // one shared data source instead of hitting the dedicated /application/push/templates/list
    // endpoint just for this dropdown.
    const fetchPushTemplateOptions = useCallback(async ({ search, ids }) => {
        if (!appId) return [];
        return fetchAjaxListData({
            type: 'notification-templates',
            q: search,
            id: ids,
            extra: { app_id: appId },
            mode: 'options',
        });
    }, [appId]);

    useEffect(() => {
        if (nodeType !== PUSH_TYPE || !draft?.template_id) { setSelectedPushTemplateRaw(null); return; }
        let cancelled = false;
        fetchPushTemplateOptions({ search: '', ids: [String(draft.template_id)] }).then((opts) => {
            if (cancelled) return;
            const raw = opts[0]?.raw || null;
            setSelectedPushTemplateRaw(raw);
            const name = raw?.text || opts[0]?.label || '';
            if (name && name !== draft.template) update('template', name);
        }).catch(() => { if (!cancelled) setSelectedPushTemplateRaw(null); });
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nodeType, draft?.template_id, appId]);

    // Template ke BODY component se {{1}}, {{2}}... jaise variables nikalne ke liye - WhatsAppPlatform.js
    // ("Send WhatsApp Message" flow) me already yehi logic h, yahan bhi wahi reuse kar rahe h.
    const getWaTemplateBodyText = (row) => {
        const comps = row && Array.isArray(row.components) ? row.components : [];
        const body = comps.find((c) => String(c.type || '').toUpperCase() === 'BODY');
        return body?.text != null ? String(body.text) : '';
    };
    const getWaTemplateVarCount = (row) => {
        const s = getWaTemplateBodyText(row);
        const re = /\{\{(\d+)\}\}/g;
        let max = 0;
        let m;
        while ((m = re.exec(s)) !== null) {
            const n = parseInt(m[1], 10);
            if (n > max) max = n;
        }
        return max;
    };

    // Automation me ab tak bane message-type nodes (Push/Email/WhatsApp) - "Previous message
    // behavior" dropdown me inhi me se ek node + ek behavior (received/clicked) choose hota h.
    const MESSAGE_TYPES = [getAutomationNodeType('push')?.value, getAutomationNodeType('email')?.value, getAutomationNodeType('whatsapp')?.value];
    const previousMessageNodes = (allNodes || []).filter((n) => MESSAGE_TYPES.includes(n.type));
    const BEHAVIOR_OPTIONS = [
        { key: 'received', label: 'has been received' },
        { key: 'not_received', label: 'has not been received' },
        { key: 'clicked', label: 'has been clicked' },
        { key: 'not_clicked', label: 'has not been clicked' },
    ];

    const addSegmentToDraft = (segment) => {
        const current = Array.isArray(draft?.segmentIds) ? draft.segmentIds : [];
        if (current.some((x) => x.id === segment.id)) return;
        update('segmentIds', [...current, { id: segment.id, name: segment.name }]);
        setShowSegmentModal(false);
    };

    const removeSegmentFromDraft = (segmentId) => {
        const current = Array.isArray(draft?.segmentIds) ? draft.segmentIds : [];
        update('segmentIds', current.filter((x) => x.id !== segmentId));
    };

    const behaviorOptions = previousMessageNodes.flatMap((n) => BEHAVIOR_OPTIONS.map((b) => ({
        value: `${n.id}::${b.key}`,
        label: `${getNodeConfigTitle(n.type)} (${n.data?.template || 'untitled'}) ${b.label}`,
    })));

    const noteBox = (
        <div className="automation-settings-channels-box mb-3">
            <h6 className="automation-settings-section-title">Note</h6>
            <textarea
                className="form-control"
                rows={3}
                placeholder="Add a note or comment..."
                value={draft?.note || ''}
                onChange={(e) => update('note', e.target.value)}
            />
        </div>
    );

    const renderGoalBox = (channelLabel) => (
        <div className="automation-settings-channels-box mb-3 beta_hide">
            <h6 className="automation-settings-section-title">Goals</h6>
            <div className="form-check d-flex align-items-center" style={{ gap: 8 }}>
                <input
                    type="checkbox"
                    className="form-check-input mt-0"
                    id={`node-goal-enabled-${channelLabel}`}
                    checked={!!draft?.goal_enabled}
                    onChange={(e) => update('goal_enabled', e.target.checked)}
                />
                <label className="form-check-label" htmlFor={`node-goal-enabled-${channelLabel}`}>Set a {channelLabel} Goal</label>
                <span className="automation-settings-beta-badge">Beta</span>
            </div>
            <p className="automation-settings-help-text" style={{ marginTop: 4 }}>
                Set a target metric to measure this message's success.{' '}
                <a href={getMarketingUrl('/docs')} target="_blank" rel="noopener noreferrer">Automations documentation</a>
            </p>

            {!!draft?.goal_enabled && (
                <>
                    <label className="automation-settings-field-label mt-3">
                        Name <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        className="form-control mb-3"
                        placeholder="Name"
                        value={draft?.goal_name || ''}
                        onChange={(e) => update('goal_name', e.target.value)}
                    />

                    <label className="automation-settings-field-label">Description (optional)</label>
                    <input
                        type="text"
                        className="form-control mb-3"
                        placeholder="Type a note or description for your goal."
                        value={draft?.goal_description || ''}
                        onChange={(e) => update('goal_description', e.target.value)}
                    />

                    <label className="automation-settings-field-label">
                        Metric <span className="text-danger">*</span>
                    </label>
                    <SelectDropdown
                        value={draft?.goal_metric}
                        groups={AUTOMATION_MESSAGE_GOAL_METRIC_GROUPS}
                        placeholder="Select a metric..."
                        onSelect={(v) => update('goal_metric', v)}
                        footer={(
                            <button
                                type="button"
                                className="automation-settings-select-locked-action"
                                onClick={(e) => e.preventDefault()}
                            >
                                <MdLockOutline size={14} /> Add custom conversion
                            </button>
                        )}
                    />
                </>
            )}
        </div>
    );

    const deliveryScheduleBox = (
        <div className="automation-settings-channels-box mb-3">
            <h6 className="automation-settings-section-title">Delivery Schedule</h6>
            <p className="automation-settings-help-text" style={{ marginBottom: 10 }}>
                This message will <strong>send immediately</strong> once the user reaches this step.
            </p>
            <div className="automation-node-tip-box">
                <MdAccessTime size={18} className="automation-node-tip-icon" />
                <span>
                    <strong>Tip:</strong> To manage what days and times this message sends at, add a <strong>Time Window</strong> action and/or a <strong>Wait</strong> action to your Automation before this message step.
                </span>
            </div>
        </div>
    );

    if (nodeType === WAIT_TYPE) {
        return (
            <>
                <div className="automation-settings-channels-box mb-3">
                    <label className="automation-settings-field-label">
                        How long to wait for <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-2 mb-2">
                        <input
                            type="number"
                            min={1}
                            className="form-control"
                            style={{ maxWidth: 110 }}
                            value={draft?.delay ?? ''}
                            onChange={(e) => update('delay', Number(e.target.value))}
                        />
                        <SelectDropdown
                            wrapStyle={{ maxWidth: 160 }}
                            value={draft?.unit}
                            options={AUTOMATION_WAIT_UNIT_CODES}
                            placeholder="Minutes"
                            onSelect={(v) => update('unit', v)}
                        />
                    </div>
                    <a href={getMarketingUrl('/docs')} target="_blank" rel="noopener noreferrer" className="automation-settings-segment-link">
                        Automations documentation
                    </a>
                </div>
                {noteBox}
            </>
        );
    }

    if (nodeType === TAG_TYPE) {
        const tags = Array.isArray(draft?.tags) && draft.tags.length ? draft.tags : [{ key: '', value: '' }];
        const updateTagAt = (i, field, value) => {
            const next = tags.map((t, idx) => (idx === i ? { ...t, [field]: value } : t));
            update('tags', next);
        };
        const addTagRow = () => update('tags', [...tags, { key: '', value: '' }]);
        const removeTagRow = (i) => update('tags', tags.filter((_, idx) => idx !== i));

        return (
            <>
                <div className="automation-settings-channels-box mb-3">
                    <label className="automation-settings-field-label d-flex align-items-center" style={{ gap: 6 }}>
                        Tag User <span className="text-danger">*</span>
                        <MdOutlineHelpOutline size={14} color="#9ca3af" />
                    </label>
                    {tags.map((t, i) => (
                        <div className="d-flex gap-2 mb-2" key={i}>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="key"
                                value={t.key}
                                onChange={(e) => updateTagAt(i, 'key', e.target.value)}
                            />
                            <input
                                type="text"
                                className="form-control"
                                placeholder="value"
                                value={t.value}
                                onChange={(e) => updateTagAt(i, 'value', e.target.value)}
                            />
                            {tags.length > 1 && (
                                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => removeTagRow(i)}>
                                    <MdClose size={14} />
                                </button>
                            )}
                        </div>
                    ))}
                    <button type="button" className="automation-settings-segment-link" onClick={addTagRow}>
                        <MdOutlineAddCircleOutline size={16} /> Add Tag
                    </button>
                </div>
                {noteBox}
            </>
        );
    }

    if (nodeType === WHATSAPP_TYPE) {
        const waBodyText = getWaTemplateBodyText(selectedWaTemplateRaw);
        const waVarCount = getWaTemplateVarCount(selectedWaTemplateRaw);
        const waVarValues = (draft?.template_variables || '').split(',').map((s) => s.trim());
        const setWaVarValue = (idx, val) => {
            const arr = [...waVarValues];
            while (arr.length < waVarCount) arr.push('');
            arr[idx] = val;
            update('template_variables', arr.join(','));
        };
        const waPreviewText = waBodyText.replace(/\{\{(\d+)\}\}/g, (m, n) => {
            const v = waVarValues[parseInt(n, 10) - 1];
            return v ? v : m;
        });
        const waHasTemplate = !!draft?.template_id;
        const waHeaderFormat = templateHeaderFormat(selectedWaTemplateRaw);
        const waNeedsFileHeader = isFileHeaderFormat(waHeaderFormat);
        const waNeedsLocationHeader = waHeaderFormat === 'LOCATION';
        // The template itself may already carry a saved default header media (set once, at
        // template-create time - see saveHeaderMediaToDisk in whatsapp.controller.js). When it
        // does, every send (including this automation step) already falls back to it automatically
        // on the backend (ensureHeaderImageComponent), so this field becomes an optional
        // override, not something the user must fill in again every time.
        const waTemplateSavedHeaderUrl = selectedWaTemplateRaw?.header_media_url || '';
        // Saved sample counts only when the backend confirmed it downloads completely (no cut-off image).
        const waTemplateDefaultHeaderUrl = waHeaderCheck.status === 'ok' ? waTemplateSavedHeaderUrl : '';
        const waHeaderOverridePreviewUrl = waHeaderFilePreview || (draft?.header_image_url || '');
        const waHeaderHasValue = !!(draft?.header_image_id || draft?.header_image_url || waHeaderFile
            || (draft?.header_latitude && draft?.header_longitude)
            || waTemplateDefaultHeaderUrl);
        const uploadWaHeaderFile = async (file) => {
            if (!appId || !file) return;
            setWaHeaderUploading(true);
            try {
                const fd = new FormData();
                fd.append('app_id', appId);
                fd.append('file', file);
                if (selectedWaTemplateRaw?.category) fd.append('template_category', selectedWaTemplateRaw.category);
                const res = await fetchWithAuth(Utils.baseurl + 'application/whatsapp/media/upload', {
                    method: 'POST',
                    body: fd,
                });
                const result = await res.json().catch(() => ({}));
                if (!result.status || !result.data?.id) {
                    throw new Error(result.message || 'Header media upload failed');
                }
                update('header_image_id', String(result.data.id));
                update('header_image_url', '');
                setWaHeaderFile(file);
            } catch (err) {
                toast.error(err.message || 'Header media upload failed');
                setWaHeaderFile(null);
            } finally {
                setWaHeaderUploading(false);
            }
        };
        return (
            <>
                <div className="automation-settings-channels-box mb-3">
                    <h6 className="automation-settings-section-title">Message Template</h6>
                    <label className="automation-settings-field-label">
                        What template do you want to send? <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-2 align-items-start">
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <AsyncSearchSelect
                                inputId="wa-template-select"
                                instanceId="wa-template-select"
                                placeholder="Type to search WhatsApp templates…"
                                fetchOptions={fetchWaTemplateOptions}
                                value={draft?.template_id || null}
                                onChange={(opt) => {
                                    update('template_id', opt?.value || '');
                                    // ajax-list rows use `.text` for the display name (toItem's
                                    // convention), not `.name` - matches fetchWaTemplateOptions'
                                    // label/raw mapping below.
                                    update('template', opt?.raw?.text || '');
                                    update('template_variables', '');
                                    update('header_image_id', '');
                                    update('header_image_url', '');
                                    update('header_latitude', '');
                                    update('header_longitude', '');
                                    setWaHeaderFile(null);
                                    setSelectedWaTemplateRaw(opt?.raw || null);
                                }}
                            />
                        </div>
                        <button type="button" className="btn btn-outline-secondary" disabled={!waHasTemplate} title="Edit template"
                            onClick={() => appId && window.open(`/apps/${appId}/whatsapp/templates`, '_blank')}>
                            <MdEdit size={14} />
                        </button>
                        <button type="button" className="btn btn-outline-secondary" disabled={!waHasTemplate}
                            onClick={() => setShowWaSendTestModal(true)}>
                            Send Test
                        </button>
                    </div>
                    <p className="automation-settings-help-text" style={{ marginTop: 6 }}>
                        Authentication/OTP templates are hidden here - approve a Marketing or Utility
                        template under WhatsApp &gt; Templates first if you don't see it in the list.
                    </p>

                    {(waNeedsFileHeader || waNeedsLocationHeader) && (
                        <div className="mt-2">
                            <label className="automation-settings-field-label">
                                Header {waNeedsLocationHeader ? 'Location' : waHeaderFormat.charAt(0) + waHeaderFormat.slice(1).toLowerCase()}
                                {!waTemplateDefaultHeaderUrl && <span className="text-danger"> *</span>}
                            </label>
                            {waNeedsFileHeader && waTemplateDefaultHeaderUrl && !waHeaderOverridePreviewUrl ? (
                                <>
                                    <p className="automation-settings-help-text" style={{ marginTop: 0, marginBottom: 6 }}>
                                        Using the media saved when this template was created - sends will use it
                                        automatically. Upload a different file or URL below only if you want to
                                        override it for this step.
                                    </p>
                                    <div className="d-flex align-items-center gap-2 mb-2">
                                        <img
                                            src={waTemplateDefaultHeaderUrl}
                                            alt="Saved template header"
                                            style={{ width: 64, height: 64, objectFit: 'cover', borderRadius: 6, border: '1px solid #e5e7eb' }}
                                        />
                                        <span className="automation-settings-help-text" style={{ marginTop: 0 }}>Saved header media</span>
                                    </div>
                                </>
                            ) : (
                                <p className="automation-settings-help-text" style={{ marginTop: 0, marginBottom: 6 }}>
                                    This template was approved with a {waHeaderFormat.toLowerCase()} header - WhatsApp
                                    requires the actual media on every send (approval only locks in the format, not
                                    reusable media). Upload a file or paste a public HTTPS URL; you can change it each time.
                                </p>
                            )}
                            {waNeedsFileHeader && (
                                <>
                                    {waHeaderOverridePreviewUrl && waHeaderFormat === 'IMAGE' && (
                                        <img
                                            src={waHeaderOverridePreviewUrl}
                                            alt="Header preview"
                                            className="mb-2"
                                            style={{ width: 96, height: 96, objectFit: 'cover', borderRadius: 6, border: '1px solid #e5e7eb' }}
                                        />
                                    )}
                                    <div className="d-flex gap-2 align-items-center mb-2">
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept={headerFileAccept(waHeaderFormat)}
                                            disabled={waHeaderUploading}
                                            onChange={(e) => {
                                                const file = e.target.files?.[0];
                                                if (file) uploadWaHeaderFile(file);
                                            }}
                                        />
                                        {waHeaderUploading && <span className="automation-settings-help-text">Uploading…</span>}
                                    </div>
                                    {draft?.header_image_id && (
                                        <p className="automation-settings-help-text" style={{ marginTop: -4 }}>
                                            Uploaded (media id: {String(draft.header_image_id).slice(0, 18)}…)
                                        </p>
                                    )}
                                    <label className="automation-settings-field-label mt-1">Or a public HTTPS URL</label>
                                    <input
                                        type="text"
                                        className="form-control mb-2"
                                        placeholder="https://example.com/header.jpg"
                                        value={draft?.header_image_url || ''}
                                        onChange={(e) => {
                                            update('header_image_url', e.target.value);
                                            if (e.target.value) { update('header_image_id', ''); setWaHeaderFile(null); }
                                        }}
                                    />
                                    {(draft?.header_image_id || draft?.header_image_url || waHeaderFile) && (
                                        <button
                                            type="button"
                                            className="automation-settings-segment-link mb-2"
                                            onClick={() => {
                                                update('header_image_id', '');
                                                update('header_image_url', '');
                                                setWaHeaderFile(null);
                                            }}
                                        >
                                            Clear override{waTemplateDefaultHeaderUrl ? ' (use saved template media)' : ''}
                                        </button>
                                    )}
                                </>
                            )}
                            {waNeedsLocationHeader && (
                                <div className="d-flex gap-2 mb-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Latitude"
                                        value={draft?.header_latitude || ''}
                                        onChange={(e) => update('header_latitude', e.target.value)}
                                    />
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Longitude"
                                        value={draft?.header_longitude || ''}
                                        onChange={(e) => update('header_longitude', e.target.value)}
                                    />
                                </div>
                            )}
                            {waNeedsFileHeader && waHeaderCheck.status === 'checking' && (
                                <p className="automation-settings-help-text" style={{ marginTop: -4 }}>Checking saved template media...</p>
                            )}
                            {waNeedsFileHeader && waHeaderCheck.status === 'bad' && (
                                <p className="text-danger automation-settings-help-text" style={{ marginTop: -4 }}>
                                    {waHeaderCheck.reason || 'Saved template media could not be downloaded completely.'} Upload an image or paste a URL to continue.
                                </p>
                            )}
                            {!waHeaderHasValue && (
                                <p className="text-danger automation-settings-help-text" style={{ marginTop: -4 }}>
                                    Required - this automation step will fail every send until header media is set.
                                </p>
                            )}
                        </div>
                    )}

                    {waHasTemplate && (
                        <div className="mt-2" >
                            <WhatsAppMessagePreview
                                bodyText={waPreviewText}
                                headerNode={waHeaderFormat === 'IMAGE' && (waHeaderOverridePreviewUrl || waTemplateDefaultHeaderUrl) ? (
                                    <img
                                        src={waHeaderOverridePreviewUrl || waTemplateDefaultHeaderUrl}
                                        alt="Header"
                                        style={{ width: '100%', borderRadius: 6, marginBottom: 6, display: 'block' }}
                                    />
                                ) : null}
                            />
                        </div>
                    )}

                    {waVarCount > 0 && (
                        <>
                            <label className="automation-settings-field-label mt-2">
                                Template Variables <span className="text-danger">*</span>
                            </label>
                            {Array.from({ length: waVarCount }).map((_, idx) => (
                                <input
                                    key={idx}
                                    type="text"
                                    className="form-control mb-2"
                                    placeholder={`Value for {{${idx + 1}}}`}
                                    value={waVarValues[idx] || ''}
                                    onChange={(e) => setWaVarValue(idx, e.target.value)}
                                />
                            ))}
                            <p className="automation-settings-help-text" style={{ marginTop: 4 }}>
                                This template has {waVarCount} variable{waVarCount > 1 ? 's' : ''} in its body
                                (e.g. an OTP code or name) - fill each one in order; the preview above updates live.
                            </p>
                        </>
                    )}
                </div>

                {showWaSendTestModal && (
                    <SendTestWhatsAppModal
                        show={showWaSendTestModal}
                        onClose={() => setShowWaSendTestModal(false)}
                        appId={appId}
                        templateName={draft?.template}
                        languageCode={selectedWaTemplateRaw?.language}
                        bodyParameters={waVarValues.slice(0, waVarCount)}
                        headerMedia={{
                            header_image_id: draft?.header_image_id || undefined,
                            header_image_url: draft?.header_image_url || undefined,
                            header_latitude: draft?.header_latitude || undefined,
                            header_longitude: draft?.header_longitude || undefined,
                        }}
                    />
                )}

                {renderGoalBox('WhatsApp')}
                {noteBox}
                {deliveryScheduleBox}
            </>
        );
    }

    if (nodeType === PUSH_TYPE) {
        const hasTemplate = !!draft?.template_id;
        return (
            <>
                <div className="automation-settings-channels-box mb-3">
                    <h6 className="automation-settings-section-title">Message Template</h6>
                    <label className="automation-settings-field-label d-flex align-items-center justify-content-between">
                        <span>What template do you want to send? <span className="text-danger">*</span></span>
                        {appId && (
                            <a href={`/apps/${appId}/push-notification`} target="_blank" rel="noopener noreferrer" className="automation-settings-add-template-link">
                                + Add Template
                            </a>
                        )}
                    </label>
                    <div className="d-flex gap-2 align-items-start">
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <AsyncSearchSelect
                                inputId="push-template-select"
                                instanceId="push-template-select"
                                placeholder="Type to search push templates…"
                                fetchOptions={fetchPushTemplateOptions}
                                value={draft?.template_id || null}
                                onChange={(opt) => {
                                    update('template_id', opt?.value || '');
                                    // ajax-list rows use `.text` for the display name (toItem's
                                    // convention), not `.name`.
                                    update('template', opt?.raw?.text || '');
                                    setSelectedPushTemplateRaw(opt?.raw || null);
                                }}
                            />
                        </div>
                        <button type="button" className="btn btn-outline-secondary" disabled={!hasTemplate} title="Edit template"
                            onClick={() => appId && draft?.template_id && window.open(`/apps/${appId}/push-notification?mode=template&template_id=${draft.template_id}`, '_blank')}>
                            <MdEdit size={14} />
                        </button>
                        <button type="button" className="btn btn-outline-secondary" disabled={!hasTemplate}
                            onClick={() => setShowPushSendTestModal(true)}>
                            Send Test Push
                        </button>
                    </div>
                    <p className="automation-settings-help-text" style={{ marginTop: 6 }}>
                        Templates come from your saved Push Notification templates - create one on the
                        Push Notification page (link above) if you don't see it in the list.
                    </p>

                    {hasTemplate && selectedPushTemplateRaw && (
                        <div className="automation-settings-push-preview mt-2">
                            <div className="automation-settings-push-preview-label">Preview</div>
                            <PushNotificationPreview
                                title={selectedPushTemplateRaw.title}
                                message={selectedPushTemplateRaw.message}
                                imageUrl={selectedPushTemplateRaw.image}
                            />
                        </div>
                    )}
                </div>

                {showPushSendTestModal && (
                    <SendTestPushAutomationModal
                        show={showPushSendTestModal}
                        onClose={() => setShowPushSendTestModal(false)}
                        appId={appId}
                        template={selectedPushTemplateRaw}
                    />
                )}

                {renderGoalBox('Push')}
                {noteBox}
                {deliveryScheduleBox}
            </>
        );
    }

    if (nodeType === EMAIL_TYPE) {
        const hasTemplate = !!draft?.template;
        return (
            <>
                <div className="automation-settings-channels-box mb-3">
                    <h6 className="automation-settings-section-title">Message Template</h6>

                    {showSenderBanner && (
                        <div className="automation-node-info-banner">
                            <div className="automation-node-info-banner-text">
                                <MdOutlineHelpOutline size={16} className="automation-node-info-banner-icon" />
                                <div>
                                    <div>Set up an authenticated sender. Without a sender, you can only send test emails.</div>
                                    <a href={getMarketingUrl('/docs')} target="_blank" rel="noopener noreferrer">Set up authenticated sender</a>
                                </div>
                            </div>
                            <MdClose size={16} className="automation-node-info-banner-close" onClick={() => setShowSenderBanner(false)} />
                    </div>
                    )}

                    <label className="automation-settings-field-label mt-2">
                        What template do you want to send? <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-2 mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Create or select a template..."
                            value={draft?.template || ''}
                            onChange={(e) => update('template', e.target.value)}
                        />
                        <button type="button" className="btn btn-outline-secondary" disabled={!hasTemplate} title="Edit template">
                            <MdEdit size={14} />
                        </button>
                        <button type="button" className="btn btn-outline-secondary" disabled={!hasTemplate}>
                            Send Test
                        </button>
                    </div>

                    <h6 className="automation-settings-section-title">Sender Settings</h6>
                    <label className="automation-settings-field-label">Sender Name</label>
                    <input
                        type="text"
                        className="form-control mb-2"
                        value={draft?.sender_name || ''}
                        onChange={(e) => update('sender_name', e.target.value)}
                    />
                    <label className="automation-settings-field-label">Sender Email</label>
                    <input
                        type="email"
                        className="form-control mb-2"
                        value={draft?.sender_email || ''}
                        onChange={(e) => update('sender_email', e.target.value)}
                    />
                    <label className="automation-settings-field-label">Reply-To Email</label>
                    <input
                        type="email"
                        className="form-control mb-2"
                        value={draft?.reply_to_email || ''}
                        onChange={(e) => update('reply_to_email', e.target.value)}
                    />

                    <button
                        type="button"
                        className="automation-settings-segment-link"
                        onClick={() => setShowAdvanced((v) => !v)}
                    >
                        <MdKeyboardArrowDown size={16} style={{ transform: showAdvanced ? 'none' : 'rotate(-90deg)', transition: 'transform 0.15s' }} />
                        View Advanced Settings
                    </button>

                    {showAdvanced && (
                        <div className="mt-2">
                            <div className="automation-node-adv-row">
                                <span>Track Link clicks</span>
                                <button
                                    type="button"
                                    className="automation-settings-segment-link"
                                    onClick={() => update('track_link_clicks', draft?.track_link_clicks === false)}
                                >
                                    {draft?.track_link_clicks === false ? 'No' : 'Yes'}
                                </button>
                            </div>
                            <div className="automation-node-adv-row">
                                <span>Include sending to unsubscribed users</span>
                                <button
                                    type="button"
                                    className="automation-settings-segment-link"
                                    onClick={() => update('include_unsubscribed', !draft?.include_unsubscribed)}
                                >
                                    {draft?.include_unsubscribed ? 'Yes' : 'No'}
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                {renderGoalBox('Email')}
                {noteBox}
                {deliveryScheduleBox}
            </>
        );
    }

    if (nodeType === CONDITION_TYPE) {
        const conditionMode = draft?.conditionMode || 'message';
        const includedSegments = Array.isArray(draft?.segmentIds) ? draft.segmentIds : [];
        const setMode = (mode) => update('conditionMode', mode);
        return (
            <>
                <div className="automation-settings-channels-box mb-3">
                    <h6 className="automation-settings-section-title">Set your branching conditions</h6>

                    <div className="automation-branch-radio-row">
                        <label className="automation-branch-radio">
                            <input type="radio" name="conditionMode" checked={conditionMode === 'event'} onChange={() => setMode('event')} />
                            <span>Custom event</span>
                            <MdOutlineHelpOutline size={14} title="Yes branch if the user performed this event after entering the automation, otherwise No branch." />
                        </label>
                        {conditionMode === 'event' && (
                            <div className="automation-branch-radio-body">
                                <EventNameSelect
                                    appId={appId}
                                    inputId="condition-event-select"
                                    value={draft?.eventName || ''}
                                    onChange={(name) => update('eventName', name)}
                                />
                                <div className="automation-branch-tip">
                                    <strong>TIP:</strong> Add a <strong>Wait</strong> step before this branch so users have time to perform the event.
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="automation-branch-radio-row">
                        <label className="automation-branch-radio">
                            <input type="radio" name="conditionMode" checked={conditionMode === 'message'} onChange={() => setMode('message')} />
                            <span>Previous message behavior</span>
                            <MdOutlineHelpOutline size={14} title="Branch users based on how they responded to a previous message in this automation." />
                        </label>
                        {conditionMode === 'message' && (
                            <div className="automation-branch-radio-body">
                                <Select
                                    inputId="condition-behavior-select"
                                    instanceId="condition-behavior-select"
                                    classNamePrefix="ns-async-select"
                                    styles={selectStyles}
                                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                    menuPosition="fixed"
                                    isClearable
                                    placeholder="Select..."
                                    options={behaviorOptions}
                                    value={behaviorOptions.find((o) => o.value === draft?.messageBehaviorKey) || null}
                                    onChange={(opt) => {
                                        update('messageBehaviorKey', opt?.value || '');
                                        update('messageBehaviorLabel', opt?.label || '');
                                    }}
                                    noOptionsMessage={() => 'No previous messages in this automation'}
                                />
                                {previousMessageNodes.length === 0 && (
                                    <div className="automation-branch-error">
                                        <MdOutlineHelpOutline size={14} /> There are no previous messages to choose from. Please add one.
                                    </div>
                                )}
                                <div className="automation-branch-tip">
                                    <strong>TIP:</strong> Add a <strong>Wait</strong> action step between your selected message and this branch so there is time for this behavior to occur.
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="automation-branch-radio-row">
                        <label className="automation-branch-radio">
                            <input type="radio" name="conditionMode" checked={conditionMode === 'segment'} onChange={() => setMode('segment')} />
                            <span>Segment membership</span>
                            <MdOutlineHelpOutline size={14} title="Branch users based on whether they belong to an existing Audience segment." />
                        </label>
                        {conditionMode === 'segment' && (
                            <div className="automation-branch-radio-body">
                                {includedSegments.map((x) => (
                                    <div key={x.id} className="automation-branch-segment-chip">
                                        <span>{x.name}</span>
                                        <MdClose size={14} onClick={() => removeSegmentFromDraft(x.id)} />
                                    </div>
                                ))}
                                <button
                                    type="button"
                                    className="automation-branch-include-segment-btn"
                                    onClick={() => setShowSegmentModal(true)}
                                >
                                    <MdAdd size={16} /> Include Segment
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                {noteBox}

                <SegmentPickerModal
                    show={showSegmentModal}
                    onHide={() => setShowSegmentModal(false)}
                    appId={appId}
                    excludeIds={includedSegments.map((x) => x.id)}
                    onSelect={(seg) => addSegmentToDraft(seg)}
                    manageLink={`/apps/${appId}/segments`}
                />
            </>
        );
    }

    return noteBox;
};

const NodeConfigPanel = ({ node, setNodes, onClose, appId, allNodes, readOnly = false }) => {
    const [draft, setDraft] = useState(node.data || {});
    const initialDataRef = useRef(null);
    if (initialDataRef.current === null) {
        initialDataRef.current = JSON.stringify(node.data || {});
    }
    const isDirty = JSON.stringify(draft) !== initialDataRef.current;

    const updateDraft = (key, value) => {
        setDraft((prev) => ({ ...prev, [key]: value }));
    };

    const handleSave = () => {
        setNodes((currentNodes) =>
            currentNodes.map((n) => (n.id === node.id ? { ...n, data: draft } : n))
        );
        onClose();
    };

    return (
        <Drawer show={true} title={getNodeConfigTitle(node.type)} onClose={onClose} onSave={handleSave} isDirty={isDirty} readOnly={readOnly}>
            <NodeConfigFields nodeType={node.type} draft={draft} update={updateDraft} appId={appId} allNodes={allNodes} />
        </Drawer>
    );
};

const InsertMenuList = ({ onSelect }) => {
    let lastGroup = null;
    return (
        <>
            {INSERT_MENU_ITEMS.map((item) => {
                const Icon = item.icon;
                const showTitle = item.group !== lastGroup;
                lastGroup = item.group;
                return (
                    <React.Fragment key={item.key}>
                        {showTitle && <div className="menu-group-title">{item.group}</div>}
                        <button onClick={() => onSelect(item.value)}>
                            <span className="menu-icon" style={{ background: item.color }}><Icon size={13} /></span>
                            <span className="menu-text">{item.label}</span>
                        </button>
                    </React.Fragment>
                );
            })}
        </>
    );
};

const AutomationSettingsPanel = ({ show, automation, appId, onClose, onSave, readOnly = false }) => {
    const [tab, setTab] = useState('Entry rules');
    const [draft, setDraft] = useState({
        entry_type: automation.entry_type,
        include_segment_ids: automation.include_segment_ids,
        exclude_segment_ids: automation.exclude_segment_ids,
        future_additions_only: automation.future_additions_only,
        entry_event_name: automation.entry_event_name,
        exit_type: automation.exit_type,
        exit_conditions: automation.exit_conditions,
        exit_event_name: automation.exit_event_name,
        exit_segment_ids: automation.exit_segment_ids,
        exit_tag: automation.exit_tag,
        reentry_type: automation.reentry_type,
        reentry_value: automation.reentry_value,
        reentry_unit: automation.reentry_unit,
        schedule_start_type: automation.schedule_start_type,
        starts_at: automation.starts_at,
        schedule_end_type: automation.schedule_end_type,
        ends_at: automation.ends_at,
        goal_enabled: automation.goal_enabled,
        goal_name: automation.goal_name,
        goal_description: automation.goal_description,
        goal_metric: automation.goal_metric,
    });

    // Outside-click/Cancel pe "Are you sure you want to leave?" confirm sirf tabhi dikhana h jab
    // kuch actually change hua ho - isliye yahi draft ka pehla (load-time) snapshot ek baar
    // capture kar liya, aage se usi se compare hota rahega.
    const initialDraftRef = useRef(null);
    if (initialDraftRef.current === null) {
        initialDraftRef.current = JSON.stringify(draft);
    }
    const isDirty = JSON.stringify(draft) !== initialDraftRef.current;
    const requestClose = async () => {
        if (isDirty && !readOnly) {
            const ok = await confirmDiscardChanges();
            if (!ok) return;
        }
        onClose();
    };

    const [segments, setSegments] = useState([]);

    // Goals tab ka "Metric" custom dropdown (native <select> ki jagah OneSignal jesa
    // panel-style dropdown chahiye tha)

    // "Select Segment" modal - Entry Rules ke Include/Exclude Segment aur Exit Rules ke
    // "Enters a segment" - teeno jagah YEHI ek modal reuse hota h. segmentPickerTarget
    // bataata h abhi kaunse field (include/exclude/exit) me add karna h, taki "+" click karte
    // hi modal khule aur usi field me add/remove ho, aur list me se wahi already-added
    // segment hat jaye (baaki do target me vo abhi bhi "available" rahenge).
    const SEGMENT_FIELD_BY_TARGET = { include: 'include_segment_ids', exclude: 'exclude_segment_ids', exit: 'exit_segment_ids' };
    // Include aur Exclude ek hi segment list ko share nahi kar sakte - jo include me h vo
    // exclude me nahi dikhna chahiye aur jo exclude me h vo include me nahi dikhna chahiye.
    const MUTUALLY_EXCLUSIVE_TARGET = { include: 'exclude', exclude: 'include' };
    const [segmentPickerTarget, setSegmentPickerTarget] = useState(null);
    const [segmentSearchTerm, setSegmentSearchTerm] = useState('');

    const [showTagModal, setShowTagModal] = useState(false);
    const [tagKeyInput, setTagKeyInput] = useState('');
    const [tagValueInput, setTagValueInput] = useState('');

    const getSegmentIds = (target) => JSON.parse(draft[SEGMENT_FIELD_BY_TARGET[target]] || '[]');
    const addSegmentTo = (target, segmentId) => {
        const ids = getSegmentIds(target);
        if (ids.includes(segmentId)) return;
        const opposite = MUTUALLY_EXCLUSIVE_TARGET[target];
        if (opposite) {
            const oppositeIds = getSegmentIds(opposite);
            if (oppositeIds.includes(segmentId)) {
                setDraft((prev) => ({
                    ...prev,
                    [SEGMENT_FIELD_BY_TARGET[target]]: JSON.stringify([...ids, segmentId]),
                    [SEGMENT_FIELD_BY_TARGET[opposite]]: JSON.stringify(oppositeIds.filter((id) => id !== segmentId)),
                }));
                return;
            }
        }
        update(SEGMENT_FIELD_BY_TARGET[target], JSON.stringify([...ids, segmentId]));
    };
    const removeSegmentFrom = (target, segmentId) => {
        update(SEGMENT_FIELD_BY_TARGET[target], JSON.stringify(getSegmentIds(target).filter((id) => id !== segmentId)));
    };

    const includeSegmentIds = getSegmentIds('include');
    const excludeSegmentIds = getSegmentIds('exclude');
    const exitSegmentIds = getSegmentIds('exit');

    // WhatsApp reach needs a server round-trip (unlike push, which already has a ready
    // subscription_count on each segment) - debounced so it doesn't fire on every keystroke
    // while segments are being added/removed.
    const [waReachCount, setWaReachCount] = useState(0);
    const includeSegmentIdsKey = includeSegmentIds.join(',');
    const excludeSegmentIdsKey = excludeSegmentIds.join(',');
    useEffect(() => {
        if (draft.entry_type !== 1 || !includeSegmentIds.length) {
            setWaReachCount(0);
            return;
        }
        let cancelled = false;
        const timer = setTimeout(() => {
            fetchAutomationSegmentChannelReach(appId, includeSegmentIds, excludeSegmentIds).then((data) => {
                if (!cancelled) setWaReachCount(data?.whatsapp || 0);
            });
        }, 400);
        return () => { cancelled = true; clearTimeout(timer); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId, draft.entry_type, includeSegmentIdsKey, excludeSegmentIdsKey]);

    const exitTags = (() => {
        try {
            const parsed = JSON.parse(draft.exit_tag || '[]');
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    })();

    const addExitTag = () => {
        if (!tagKeyInput.trim()) return;
        update('exit_tag', JSON.stringify([...exitTags, { key: tagKeyInput.trim(), value: tagValueInput.trim() }]));
        setTagKeyInput('');
        setTagValueInput('');
        setShowTagModal(false);
    };
    const removeExitTag = (index) => {
        update('exit_tag', JSON.stringify(exitTags.filter((_, i) => i !== index)));
    };

    useEffect(() => {
        if (!show) return;
        fetchWithAuth(Utils.baseurl + 'get/segments', {
            method: 'POST',
            body: JSON.stringify({ app_id: automation.applicationId, pageSize: 1000 }),
        })
            .then((r) => r.json())
            .then((result) => { if (result.status) setSegments(result.data || []); })
            .catch(() => { });
    }, [show, automation.applicationId]);

    const update = (key, value) => setDraft((prev) => ({ ...prev, [key]: value }));

    if (!show) return null;



    return (
        <>
            <div className="automation-config-drawer-backdrop" onClick={requestClose} />
            <div className="automation-config-drawer" style={{ width: 'calc(var(--automation-drawer-width) + 190px)' }}>
            <div className="automation-config-drawer-header">
                <h5 className="m-0">Automation Settings</h5>
                <div className="drawer-actions">
                    <button type="button" className="btn_theme_secondary" onClick={requestClose}>{readOnly ? 'Close' : 'Cancel'}</button>
                    {!readOnly && (
                        <button type="button" className="add_app_btn btn_theme_primary" onClick={() => onSave(draft)}><span>Save</span></button>
                    )}
                </div>
            </div>
            <fieldset disabled={readOnly} className="automation-config-drawer-body automation-readonly-fieldset d-flex" style={{ gap: 20 }}>
                <div className="automation-settings-tabs-list" style={{ width: 150, flexShrink: 0 }}>
                    {TABS.map((t) => (
                        <div
                            key={t}
                            className={`automation-settings-tab-item ${tab === t ? 'active' : ''} ${t === 'Goals' ? 'beta_hide' : ''}`}
                            onClick={() => setTab(t)}
                        >
                            {t}
                        </div>
                    ))}
                </div>
                <div style={{ flex: 1 }}>
                    {tab === 'Entry rules' && (
                        <>
                            <h6 className="automation-settings-section-title">Entry Rules</h6>

                            <div className="automation-settings-option-cards mb-3">
                                <div
                                    className={`automation-settings-option-card ${draft.entry_type === 1 ? 'active' : ''}`}
                                    onClick={() => update('entry_type', 1)}
                                >
                                    <span className="automation-settings-option-icon"><MdOutlinePieChart size={20} /></span>
                                    <h6>Audience Segment</h6>
                                    <p>Users in the chosen segment will start your Automation</p>
                                </div>
                                <div
                                    className={`automation-settings-option-card ${draft.entry_type === 2 ? 'active' : ''}`}
                                    onClick={() => update('entry_type', 2)}
                                >
                                    <span className="automation-settings-option-icon"><MdOutlineBolt size={20} /></span>
                                    <h6>Custom Event</h6>
                                    <p>Start your automation when a custom event happens</p>
                                </div>
                            </div>

                            {draft.entry_type === 1 && (
                                <>
                                    <label className="automation-settings-field-label">
                                        What segment(s) should be <strong>included</strong> in this Automation? <span className="text-danger">*</span>
                                    </label>
                                    <div className="automation-settings-chip-row mb-3">
                                        {includeSegmentIds.map((id) => {
                                            const seg = segments.find((s) => s.id === id);
                                            return (
                                                <span className="automation-settings-chip" key={id}>
                                                    <MdOutlinePieChart size={13} />
                                                    {seg?.name || `Segment #${id}`}
                                                    <MdClose size={13} className="automation-settings-chip-remove" onClick={() => removeSegmentFrom('include', id)} />
                                                </span>
                                            );
                                        })}
                                        <button type="button" className="automation-settings-segment-link" onClick={() => setSegmentPickerTarget('include')}>
                                            <MdOutlineAddCircleOutline size={16} /> Include Segment
                                        </button>
                                    </div>

                                    <label className="automation-settings-field-label">
                                        What segment(s) should be <strong>excluded</strong> from this Automation?
                                    </label>
                                    <div className="automation-settings-chip-row mb-3">
                                        {excludeSegmentIds.map((id) => {
                                            const seg = segments.find((s) => s.id === id);
                                            return (
                                                <span className="automation-settings-chip" key={id}>
                                                    <MdOutlinePieChart size={13} />
                                                    {seg?.name || `Segment #${id}`}
                                                    <MdClose size={13} className="automation-settings-chip-remove" onClick={() => removeSegmentFrom('exclude', id)} />
                                                </span>
                                            );
                                        })}
                                        <button type="button" className="automation-settings-segment-link" onClick={() => setSegmentPickerTarget('exclude')}>
                                            <MdOutlineRemoveCircleOutline size={16} /> Exclude Segment
                                        </button>
                                    </div>
                                </>
                            )}

                            {draft.entry_type === 2 && (
                                <>
                                    <label className="automation-settings-field-label">Event Name</label>
                                    <div className="mb-3">
                                        <EventNameSelect
                                            appId={appId}
                                            inputId="automation-entry-event-select"
                                            value={draft.entry_event_name || ''}
                                            onChange={(name) => update('entry_event_name', name)}
                                        />
                                    </div>
                                </>
                            )}

                            <hr className="automation-settings-divider" />

                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="automation-future-additions-only"
                                    checked={!!draft.future_additions_only}
                                    onChange={(e) => update('future_additions_only', e.target.checked ? 1 : 0)}
                                />
                                <label className="form-check-label" htmlFor="automation-future-additions-only">Future additions only</label>
                            </div>
                            <p className="automation-settings-help-text">Only include users that match segment(s) in the future once this automation is live.</p>

                            <hr className="automation-settings-divider" />

                            <div className="automation-settings-field-label d-flex align-items-center" style={{ gap: 6 }}>
                                Recommended Channels
                                <MdOutlineHelpOutline size={14} title="Estimated reach per channel for the segment(s) selected above" />
                            </div>
                            {/* Push ke liye already segments list me saved "subscription_count" use kar rahe h
                                (yehi field PushNotification.js me bhi "Total Subscribers" dikhane ke liye use
                                hota h) - included segment(s) ke subscription_count jod diye. Email/In-App/
                                SMS-RCS/WhatsApp ke liye abhi koi channel-wise count data/API nahi h, isliye vo
                                0 hi rehte h jab tak vo data available na ho.
                                Rows ki LIST khud AUTOMATION_NODE_TYPE_CODES (commonUtils.mjs) ke "Messages" group
                                se aati h - taaki jab bhi koi channel (in_app/sms) vahan uncomment/comment ho,
                                yeh yahan bina koi extra badlav ke khud show/hide ho jaye. */}
                            <div className="automation-settings-channels-box">
                                {(() => {
                                    const pushCount = draft.entry_type === 1
                                        ? includeSegmentIds.reduce((total, id) => {
                                            const seg = segments.find((s) => s.id === id);
                                            return total + (Number(seg?.subscription_count) || 0);
                                        }, 0)
                                        : 0;
                                    const channelCounts = { push: pushCount, whatsapp: waReachCount };
                                    const channelShortLabels = { push: 'Push', email: 'Email', in_app: 'In-App', sms: 'SMS/RCS', whatsapp: 'WhatsApp' };
                                    const rows = AUTOMATION_NODE_TYPE_CODES
                                        .filter((item) => item.group === 'Messages')
                                        .map((item) => ({
                                            label: channelShortLabels[item.key] || item.label,
                                            value: channelCounts[item.key] || 0,
                                        }));
                                    const maxValue = Math.max(...rows.map((r) => r.value), 1);
                                    return rows.map(({ label, value }) => (
                                        <div className="automation-settings-channel-row" key={label}>
                                            <span className="automation-settings-channel-label">{label}</span>
                                            <span className="automation-settings-channel-bar">
                                                {value > 0 && (
                                                    <span
                                                        className="automation-settings-channel-bar-fill"
                                                        style={{ width: `${Math.max((value / maxValue) * 100, 6)}%` }}
                                                    />
                                                )}
                                            </span>
                                            <span className="automation-settings-channel-value">{value.toLocaleString()}</span>
                                        </div>
                                    ));
                                })()}
                            </div>
                        </>
                    )}
                    {tab === 'Goals' && (
                        <div className="beta_hide">
                            <h6 className="automation-settings-section-title">Goals</h6>

                            <div className="form-check d-flex align-items-center" style={{ gap: 8 }}>
                                <input
                                    type="checkbox"
                                    className="form-check-input mt-0"
                                    id="automation-goal-enabled"
                                    checked={!!draft.goal_enabled}
                                    onChange={(e) => update('goal_enabled', e.target.checked ? 1 : 0)}
                                />
                                <label className="form-check-label" htmlFor="automation-goal-enabled">Set an Automation Goal</label>
                                <span className="automation-settings-beta-badge">Beta</span>
                            </div>
                            <p className="automation-settings-help-text" style={{ marginTop: 4 }}>
                                Set a target metric to measure this Automation's success.{' '}
                                <a href={getMarketingUrl('/docs')} target="_blank" rel="noopener noreferrer">Automations documentation</a>
                            </p>

                            {!!draft.goal_enabled && (
                                <>
                                    <label className="automation-settings-field-label mt-3">
                                        Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        placeholder="Name"
                                        value={draft.goal_name || ''}
                                        onChange={(e) => update('goal_name', e.target.value)}
                                    />

                                    <label className="automation-settings-field-label">Description (optional)</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        placeholder="Type a note or description for your goal."
                                        value={draft.goal_description || ''}
                                        onChange={(e) => update('goal_description', e.target.value)}
                                    />

                                    <label className="automation-settings-field-label">
                                        Metric <span className="text-danger">*</span>
                                    </label>
                                    <SelectDropdown
                                        value={draft.goal_metric}
                                        options={AUTOMATION_GOAL_METRIC_CODES}
                                        placeholder="Select a metric..."
                                        onSelect={(v) => update('goal_metric', v)}
                                    />
                                </>
                            )}
                        </div>
                    )}
                    {tab === 'Exit rules' && (
                        <>
                            <h6 className="automation-settings-section-title">Exit Rules</h6>
                            <label className="automation-settings-field-label">When should users exit this Automation?</label>

                            <div
                                className={`automation-settings-radio-card ${draft.exit_type === 1 ? 'active' : ''}`}
                                onClick={() => update('exit_type', 1)}
                            >
                                <span className={`automation-settings-radio ${draft.exit_type === 1 ? 'checked' : ''}`} />
                                <div>
                                    <div className="automation-settings-radio-title">They moved through the entire Automation</div>
                                    <div className="automation-settings-radio-desc">Users exit when they have moved through the full Automation.</div>
                                </div>
                            </div>

                            <div
                                className={`automation-settings-radio-card ${draft.exit_type === 2 ? 'active' : ''}`}
                                onClick={() => update('exit_type', 2)}
                            >
                                <span className={`automation-settings-radio ${draft.exit_type === 2 ? 'checked' : ''}`} />
                                <div style={{ flex: 1 }}>
                                    <div className="automation-settings-radio-title">Meet a certain condition</div>
                                    <div className="automation-settings-radio-desc">Users exit when they match the rules you have set on a particular segment or condition.</div>

                                    {draft.exit_type === 2 && (
                                        <div className="automation-settings-radio-card-body" onClick={(e) => e.stopPropagation()}>
                                            {AUTOMATION_EXIT_CONDITION_BITS.map(({ value: bit, label, tooltip }) => (
                                                <React.Fragment key={bit}>
                                                    <div className="form-check d-flex align-items-center" style={{ gap: 6 }}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input mt-0"
                                                            id={`automation-exit-cond-${bit}`}
                                                            checked={!!(draft.exit_conditions & bit)}
                                                            onChange={(e) =>
                                                                update('exit_conditions', e.target.checked
                                                                    ? (draft.exit_conditions | bit)
                                                                    : (draft.exit_conditions & ~bit))
                                                            }
                                                        />
                                                        <label className="form-check-label" htmlFor={`automation-exit-cond-${bit}`}>{label}</label>
                                                        {tooltip && <MdOutlineHelpOutline size={14} color="#9ca3af" />}
                                                    </div>

                                                    {bit === 2 && !!(draft.exit_conditions & 2) && (
                                                        <div className="mt-2 mb-2">
                                                            <label className="automation-settings-field-label">
                                                                Custom Event Name <span className="text-danger">*</span>
                                                            </label>
                                                            <EventNameSelect
                                                                appId={appId}
                                                                inputId="automation-exit-event-select"
                                                                value={draft.exit_event_name || ''}
                                                                onChange={(name) => update('exit_event_name', name)}
                                                            />
                                                        </div>
                                                    )}

                                                    {bit === 8 && !!(draft.exit_conditions & 8) && (
                                                        <div className="automation-settings-chip-row mt-2 mb-2">
                                                            {exitSegmentIds.map((id) => {
                                                                const seg = segments.find((s) => s.id === id);
                                                                return (
                                                                    <span className="automation-settings-chip" key={id}>
                                                                        <MdOutlinePieChart size={13} />
                                                                        {seg?.name || `Segment #${id}`}
                                                                        <MdClose size={13} className="automation-settings-chip-remove" onClick={() => removeSegmentFrom('exit', id)} />
                                                                    </span>
                                                                );
                                                            })}
                                                            <button type="button" className="automation-settings-segment-link" onClick={() => setSegmentPickerTarget('exit')}>
                                                                <MdOutlineAddCircleOutline size={16} /> Include Segment
                                                            </button>
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            ))}

                                            <hr className="automation-settings-divider" style={{ margin: '14px 0' }} />

                                            <div className="d-flex align-items-center" style={{ gap: 6, marginBottom: 8 }}>
                                                <span className="automation-settings-field-label" style={{ marginBottom: 0 }}>Tag users when they exit early</span>
                                                <MdOutlineHelpOutline size={14} color="#9ca3af" />
                                            </div>
                                            <div className="automation-settings-chip-row">
                                                {exitTags.map((t, i) => (
                                                    <span className="automation-settings-chip" key={`${t.key}-${i}`}>
                                                        <MdOutlineLocalOffer size={13} />
                                                        <strong>{t.key}</strong>{t.value ? `: ${t.value}` : ''}
                                                        <MdClose size={13} className="automation-settings-chip-remove" onClick={() => removeExitTag(i)} />
                                                    </span>
                                                ))}
                                                <button type="button" className="automation-settings-segment-link" onClick={() => setShowTagModal(true)}>
                                                    <MdOutlineAddCircleOutline size={16} /> Tag
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                    {tab === 'Re-entry rules' && (
                        <>
                            <h6 className="automation-settings-section-title">Re-entry Rules</h6>
                            <label className="automation-settings-field-label">Can a user re-enter an Automation after exiting or finishing?</label>

                            <div
                                className={`automation-settings-radio-card ${draft.reentry_type === 1 ? 'active' : ''}`}
                                onClick={() => update('reentry_type', 1)}
                            >
                                <span className={`automation-settings-radio ${draft.reentry_type === 1 ? 'checked' : ''}`} />
                                <div>
                                    <div className="automation-settings-radio-title">No, they can receive this only once</div>
                                    <div className="automation-settings-radio-desc">Users only receive messages from this Automation once.</div>
                                </div>
                            </div>

                            <div
                                className={`automation-settings-radio-card ${draft.reentry_type === 2 ? 'active' : ''}`}
                                onClick={() => update('reentry_type', 2)}
                            >
                                <span className={`automation-settings-radio ${draft.reentry_type === 2 ? 'checked' : ''}`} />
                                <div style={{ flex: 1 }}>
                                    <div className="automation-settings-radio-title">Yes, after a certain amount of time</div>
                                    <div className="automation-settings-radio-desc">Users re-enter the Automation after a period of time if they match the entry rules.</div>

                                    {draft.reentry_type === 2 && (
                                        <div className="automation-settings-radio-card-body d-flex gap-2" onClick={(e) => e.stopPropagation()}>
                                            <input
                                                type="number"
                                                min={1}
                                                className="form-control"
                                                style={{ maxWidth: 100 }}
                                                value={draft.reentry_value || ''}
                                                onChange={(e) => update('reentry_value', Number(e.target.value))}
                                            />
                                            <SelectDropdown
                                                wrapStyle={{ maxWidth: 160 }}
                                                value={draft.reentry_unit}
                                                options={AUTOMATION_WAIT_UNIT_CODES}
                                                placeholder="Days"
                                                onSelect={(v) => update('reentry_unit', v)}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                    {tab === 'Schedule' && (
                        <>
                            <h6 className="automation-settings-section-title">Schedule</h6>
                            <label className="automation-settings-field-label">Choose when an Automation <strong>starts</strong></label>

                            <div
                                className={`automation-settings-radio-card ${draft.schedule_start_type === 1 ? 'active' : ''}`}
                                onClick={() => update('schedule_start_type', 1)}
                            >
                                <span className={`automation-settings-radio ${draft.schedule_start_type === 1 ? 'checked' : ''}`} />
                                <div>
                                    <div className="automation-settings-radio-title">Start immediately</div>
                                    <div className="automation-settings-radio-desc">Your Automation will become active as soon as you set it live.</div>
                                </div>
                            </div>

                            <div
                                className={`automation-settings-radio-card ${draft.schedule_start_type === 2 ? 'active' : ''}`}
                                onClick={() => update('schedule_start_type', 2)}
                            >
                                <span className={`automation-settings-radio ${draft.schedule_start_type === 2 ? 'checked' : ''}`} />
                                <div style={{ flex: 1 }}>
                                    <div className="automation-settings-radio-title">Schedule a start date and time</div>
                                    <div className="automation-settings-radio-desc">Your Automation will be become active at a specific time and date.</div>

                                    {draft.schedule_start_type === 2 && (
                                        <div className="automation-settings-radio-card-body" onClick={(e) => e.stopPropagation()}>
                                            <DateTimePicker
                                                date={draft.starts_at ? toLocalIsoDate(new Date(draft.starts_at)) : toLocalIsoDate()}
                                                time={draft.starts_at ? toLocalIsoTime(new Date(draft.starts_at)) : toLocalIsoTime()}
                                                onChange={({ date, time }) => {
                                                    const dt = combineLocalDateTime(date, time);
                                                    update('starts_at', dt ? dt.toISOString() : '');
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>

                            <hr className="automation-settings-divider" />

                            <label className="automation-settings-field-label">Choose when an Automation <strong>ends</strong></label>

                            <div
                                className={`automation-settings-radio-card ${draft.schedule_end_type === 1 ? 'active' : ''}`}
                                onClick={() => update('schedule_end_type', 1)}
                            >
                                <span className={`automation-settings-radio ${draft.schedule_end_type === 1 ? 'checked' : ''}`} />
                                <div>
                                    <div className="automation-settings-radio-title">Never stops</div>
                                    <div className="automation-settings-radio-desc">Your Automation will stay active indefinitely.</div>
                                </div>
                            </div>

                            <div
                                className={`automation-settings-radio-card ${draft.schedule_end_type === 2 ? 'active' : ''}`}
                                onClick={() => update('schedule_end_type', 2)}
                            >
                                <span className={`automation-settings-radio ${draft.schedule_end_type === 2 ? 'checked' : ''}`} />
                                <div style={{ flex: 1 }}>
                                    <div className="automation-settings-radio-title">Schedule an end date and time</div>
                                    <div className="automation-settings-radio-desc">Your Automation will stop on specific time and date.</div>

                                    {draft.schedule_end_type === 2 && (
                                        <div className="automation-settings-radio-card-body" onClick={(e) => e.stopPropagation()}>
                                            <DateTimePicker
                                                date={draft.ends_at ? toLocalIsoDate(new Date(draft.ends_at)) : toLocalIsoDate()}
                                                time={draft.ends_at ? toLocalIsoTime(new Date(draft.ends_at)) : toLocalIsoTime()}
                                                onChange={({ date, time }) => {
                                                    const dt = combineLocalDateTime(date, time);
                                                    update('ends_at', dt ? dt.toISOString() : '');
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </fieldset>

            <div className="automation-settings-pagination">
                <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    disabled={TABS.indexOf(tab) === 0}
                    onClick={() => setTab(TABS[TABS.indexOf(tab) - 1])}
                >Previous</button>
                <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    disabled={TABS.indexOf(tab) === TABS.length - 1}
                    onClick={() => setTab(TABS[TABS.indexOf(tab) + 1])}
                >Next</button>
            </div>

            <SegmentPickerModal
                show={!!segmentPickerTarget}
                onHide={() => { setSegmentPickerTarget(null); setSegmentSearchTerm(''); }}
                appId={automation.applicationId}
                segments={segments}
                excludeIds={segmentPickerTarget ? [
                    ...getSegmentIds(segmentPickerTarget),
                    ...(MUTUALLY_EXCLUSIVE_TARGET[segmentPickerTarget] ? getSegmentIds(MUTUALLY_EXCLUSIVE_TARGET[segmentPickerTarget]) : []),
                ] : []}
                onSelect={(s) => addSegmentTo(segmentPickerTarget, s.id)}
                manageLink={`/apps/${automation.applicationId}/segments`}
            />

            <Modal show={showTagModal} onHide={() => { setShowTagModal(false); setTagKeyInput(''); setTagValueInput(''); }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Tag User On Early Exit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="automation-settings-help-text" style={{ marginBottom: 16 }}>
                        This will add a tag to the user when they exit the Automation early. if value is left empty the tag will be removed if it exists.
                    </p>
                    <div className="d-flex" style={{ gap: 12 }}>
                        <div style={{ flex: 1 }}>
                            <label className="automation-settings-field-label">
                                Key <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="e.g. In-Automation"
                                value={tagKeyInput}
                                onChange={(e) => setTagKeyInput(e.target.value)}
                                autoFocus
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <label className="automation-settings-field-label">Value</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="e.g. False"
                                value={tagValueInput}
                                onChange={(e) => setTagValueInput(e.target.value)}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-link btn-sm"
                        onClick={() => { setShowTagModal(false); setTagKeyInput(''); setTagValueInput(''); }}
                    >Cancel</button>
                    <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        disabled={!tagKeyInput.trim()}
                        onClick={addExitTag}
                    >Save</button>
                </Modal.Footer>
            </Modal>
            </div>
        </>
    );
};


// The Join node that closes a Condition block: the Join tagged with this Condition's id, or (for
// safety) the first Join reached down its first branch, stepping over any nested blocks.
const findJoinOf = (condId, byId, outMap) => {
    const JOIN = getAutomationNodeType('join')?.value;
    const COND = getAutomationNodeType('condition')?.value;
    const tagged = Object.keys(byId).find((id) => byId[id].type === JOIN && byId[id].data?.conditionId === condId);
    if (tagged) return tagged;
    const firstOut = (id) => (outMap[id] || [])[0]?.target;
    let cur = firstOut(condId);
    const seen = new Set();
    while (cur && byId[cur] && !seen.has(cur)) {
        seen.add(cur);
        const n = byId[cur];
        if (n.type === JOIN) return cur;
        if (n.type === COND) {
            const j = findJoinOf(cur, byId, outMap);
            if (!j) return null;
            cur = firstOut(j);
            continue;
        }
        cur = firstOut(cur);
    }
    return null;
};

const AutomationBuilder = () => {

    const ENTRANCE_TYPE = getAutomationNodeType('entrance')?.value;
    const EXIT_TYPE = getAutomationNodeType('exit')?.value;
    const CONDITION_TYPE = getAutomationNodeType('condition')?.value;
    const JOIN_TYPE = getAutomationNodeType('join')?.value;

    // Condition node ke hamesha DO outgoing edges hone chahiye - "Yes" aur "No" (dono niche
    // jaake wapas usi node pe mil/merge ho jate h). Card pe ab sirf EK Handle h (id="out"),
    // isliye Yes/No ki pehchaan Handle id se nahi, edge.data.branch se hoti h. Yeh helper teeno
    // purane formats se migrate kar deta h: (a) bilkul purana - koi sourceHandle/branch nahi,
    // (b) pichle round ka - alag "yes"/"no" Handles (sourceHandle se), (c) already naya format.
    // Jo bhi mile, sabko normalize karke sourceHandle:'out' + data.branch pe le aata h.
    const ensureConditionBranches = (nds, eds) => {
        let result = eds;
        const isYes = (e) => e.data?.branch === 'yes' || e.sourceHandle === 'yes';
        const isNo = (e) => e.data?.branch === 'no' || e.sourceHandle === 'no';
        const normalize = (e, branch) => ({ ...e, sourceHandle: 'out', data: { ...e.data, branch } });

        nds.forEach((n) => {
            if (n.type !== CONDITION_TYPE) return;
            const outs = result.filter((e) => e.source === n.id);
            const yesEdge = outs.find(isYes);
            const noEdge = outs.find(isNo);
            const legacyEdge = outs.find((e) => !isYes(e) && !isNo(e));

            if (yesEdge && noEdge) {
                // Dono mil gaye - bas purane Handle-id format ko naye single-handle (data.branch)
                // format me normalize kar do, taaki card pe do alag dots na dikhe.
                result = result.map((e) => {
                    if (e.id === yesEdge.id) return normalize(e, 'yes');
                    if (e.id === noEdge.id) return normalize(e, 'no');
                    return e;
                });
                return;
            }

            if (legacyEdge) {
                // Bilkul purana single edge - use "yes" bana do, aur usi target ki taraf "no" bhi jod do
                result = result.map((e) => (e.id === legacyEdge.id ? normalize(e, 'yes') : e));
                if (!noEdge) {
                    result = [...result, normalize({ id: `e_${n.id}_no_${legacyEdge.target}`, source: n.id, target: legacyEdge.target }, 'no')];
                }
            } else if (yesEdge && !noEdge) {
                result = result.map((e) => (e.id === yesEdge.id ? normalize(e, 'yes') : e));
                result = [...result, normalize({ id: `e_${n.id}_no_${yesEdge.target}`, source: n.id, target: yesEdge.target }, 'no')];
            } else if (noEdge && !yesEdge) {
                result = result.map((e) => (e.id === noEdge.id ? normalize(e, 'no') : e));
                result = [...result, normalize({ id: `e_${n.id}_yes_${noEdge.target}`, source: n.id, target: noEdge.target }, 'yes')];
            }
        });
        return result;
    };


    // Older automations (saved before Conditions had their own Join node) let a Condition's
    // branches - and those of any Condition nested inside them - all land on one shared "next"
    // node. Convert that into explicit blocks: for every Condition, find the edges where its
    // branches end, point them at a new Join for that Condition, and connect Join -> that next
    // node. Inner blocks are closed first (recursively), so nesting of any depth comes out right.
    const ensureJoinNodes = (nds, eds) => {
        let nodesOut = [...nds];
        let edgesOut = [...eds];
        const byIdNow = () => { const m = {}; nodesOut.forEach((n) => { m[n.id] = n; }); return m; };
        const outsOf = (id) => edgesOut.filter((e) => e.source === id);
        const insOf = (id) => edgesOut.filter((e) => e.target === id);
        const done = {};
        const closeBlock = (condId) => {
            if (condId in done) return done[condId];
            done[condId] = null; // cycle guard
            const byId = byIdNow();
            const outs = outsOf(condId);
            if (outs.length < 2) return null;
            const followBranch = (edge) => {
                let e = edge;
                const seen = new Set();
                while (e && !seen.has(e.id)) {
                    seen.add(e.id);
                    const t = byIdNow()[e.target];
                    if (!t) return null;
                    if (t.type === JOIN_TYPE || insOf(t.id).length > 1) return e;
                    if (t.type === CONDITION_TYPE) {
                        const j = closeBlock(t.id);
                        if (!j) return null;
                        e = outsOf(j)[0];
                        continue;
                    }
                    const o = outsOf(t.id);
                    if (o.length !== 1) return null; // exit / dead end / unexpected fork
                    e = o[0];
                }
                return null;
            };
            const tails = outs.map(followBranch);
            if (tails.some((t) => !t)) return null;
            const targets = [...new Set(tails.map((t) => t.target))];
            if (targets.length !== 1) return null;
            const mergeId = targets[0];
            const tailIds = new Set(tails.map((t) => t.id));
            const mergeNode = byIdNow()[mergeId];
            if (mergeNode?.type === JOIN_TYPE && insOf(mergeId).every((e) => tailIds.has(e.id))) {
                done[condId] = mergeId;
                return mergeId;
            }
            if (!byId[condId]) return null;
            const join = makeJoinNode(condId);
            if (byId[join.id]) join.id = `join-${condId}-${uid()}`;
            nodesOut = [...nodesOut, join];
            edgesOut = [
                ...edgesOut.map((e) => (tailIds.has(e.id) ? { ...e, target: join.id } : e)),
                makeEdge(join.id, mergeId),
            ];
            done[condId] = join.id;
            return join.id;
        };
        nds.filter((n) => n.type === CONDITION_TYPE).forEach((n) => closeBlock(n.id));
        return { nodes: nodesOut, edges: edgesOut };
    };

    const params = useParams();
    const navigate = useNavigate();

    const appId = params.appId;
    const automationId = params.automationId;

    const [automation, setAutomation] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [showMoreMenu, setShowMoreMenu] = useState(false);
    const [showAuditModal, setShowAuditModal] = useState(false);
    const [auditLogs, setAuditLogs] = useState([]);
    const [auditLoading, setAuditLoading] = useState(false);
    const [showAutomationSettings, setShowAutomationSettings] = useState(false);

    // Live per-node occupancy ("kitne user kis card pe h") - fetched once the automation is loaded
    // and refreshed every 20s while the builder stays open, so the numbers on canvas stay
    // roughly live without the user having to reload the page.
    const [nodeCounts, setNodeCounts] = useState({});
    const [showNodeUsersModal, setShowNodeUsersModal] = useState(false);
    const [nodeUsersTarget, setNodeUsersTarget] = useState(null); // { id, label } | null
    const [nodeUsersResult, setNodeUsersResult] = useState(null);
    const [nodeUsersLoading, setNodeUsersLoading] = useState(false);
    const [nodeUsersPage, setNodeUsersPage] = useState(1);

    const insertMenuRef = useRef(null);

    const [nodes, setNodes] = useState([]);
    const [edges, setEdges] = useState([]);
    const [viewport, setViewport] = useState({
        x: 0,
        y: 0,
        zoom: 1,
    });

    // Automation graph ka last-saved snapshot - back button / browser refresh pe "unsaved changes"
    // pata karne ke liye (position round kar diya h taaki chhoti-si float jitter se galat-"dirty"
    // na dikhe). computeLayout() se return hui node list hamesha isi se compare hoti h.
    const savedGraphRef = useRef(null);
    // Position ko diff me shamil NAHI karte - vo hamesha computeLayout() se (edges + measured
    // height se) derive hoti h, user kabhi directly position set nahi karta (drag bhi snap-back
    // ho jata h). Agar position include karte to React Flow ke asli height measure hone ke baad
    // wali automatic re-layout (fallback height se exact height tak) hi "unsaved change" dikha
    // deti, chahe user ne kuch bhi na badla ho - isiliye sirf id/type/data (nodes) aur edges hi
    // compare karte h.
    const normalizeGraphForDiff = (nds, eds) => JSON.stringify({
        nodes: nds
            .map((n) => ({
                id: n.id,
                type: n.type,
                data: n.data,
            }))
            .sort((a, b) => a.id.localeCompare(b.id)),
        edges: eds
            .map((e) => ({ id: e.id, source: e.source, target: e.target, sourceHandle: e.sourceHandle || null }))
            .sort((a, b) => a.id.localeCompare(b.id)),
    });
    const isAutomationDirty = () => savedGraphRef.current !== null && normalizeGraphForDiff(nodes, edges) !== savedGraphRef.current;

    const [selectedNode, setSelectedNode] = useState(null);
    const [selectedNodeId, setSelectedNodeId] = useState(null);
    const nodeTypes = {
        [getAutomationNodeType('entrance')?.value]: EntranceNode,
        [getAutomationNodeType('wait')?.value]: WaitNode,
        [getAutomationNodeType('condition')?.value]: ConditionNode,
        [getAutomationNodeType('exit')?.value]: ExitNode,
        [getAutomationNodeType('push')?.value]: PushNotification,
        [getAutomationNodeType('email')?.value]: EmailNode,
        [getAutomationNodeType('in_app')?.value]: InAppNode,
        [getAutomationNodeType('sms')?.value]: SmsNode,
        [getAutomationNodeType('tag')?.value]: TagNode,
        [getAutomationNodeType('whatsapp')?.value]: WhatsAppNode,
        [getAutomationNodeType('join')?.value]: JoinNode,
        dragGhost: DragGhostNode,
    }

    const [validation, setValidation] = useState({ ok: true, errors: [] });
    const [showSetLiveModal, setShowSetLiveModal] = useState(false);
    const [setLiveChecking, setSetLiveChecking] = useState(false);
    const [setLiveResult, setSetLiveResult] = useState(null);
    const [settingLive, setSettingLive] = useState(false);
    const [insertMenu, setInsertMenu] = useState(null); // { edgeId, x, y } | null
    const [dropTargetEdgeId, setDropTargetEdgeId] = useState(null); // drag-drop reorder ke time hover wali edge
    const [openActionsMenuId, setOpenActionsMenuId] = useState(null); // kis card ka "..." menu khula h (uski z-index upar uthane ke liye)
    const [dragState, setDragState] = useState(null); // { nodeId, origin: {x,y}, width, height } - drag ke time ka ghost placeholder
    const [rfInstance, setRfInstance] = useState(null); // React Flow instance (focus a card / export image)
    // After a failed "Set Live" check the cards that failed are outlined in red (and stay so,
    // live-updating as the user fixes them, until the automation finally goes live).
    const [highlightErrors, setHighlightErrors] = useState(false);
    // Live / Ended / Archived automations are view-only: a live flow has users moving through it right
    // now, so it must be paused before it can change.
    const isReadOnlyAutomation = automation ? [3, 5, 6].includes(Number(automation.status)) : false;

    const handleOpenInsertMenu = (edgeId) => {
        setSelectedNodeId(null);
        setShowAuditModal(false);
        setShowMoreMenu(false);
        setInsertMenu({ edgeId });
    };

    // Exports the WHOLE flow (not just what's visible on screen): the image is sized to the bounding
    // box of all cards and the viewport is temporarily re-positioned to it, so zoom / pan / a flow
    // taller than the window don't cut anything off.
    const exportImage = async () => {
        if (!rfInstance) return;
        const flowNodes = rfInstance.getNodes().filter((n) => n.type !== 'dragGhost');
        const viewportEl = document.querySelector('.automation-canvas .react-flow__viewport');
        if (!flowNodes.length || !viewportEl) {
            toast.error('Nothing to export yet');
            return;
        }
        const bounds = getNodesBounds(flowNodes);
        const pad = 80;
        const width = Math.ceil(bounds.width + pad * 2);
        const height = Math.ceil(bounds.height + pad * 2);
        const options = {
            backgroundColor: '#ffffff',
            width,
            height,
            pixelRatio: 2,
            style: {
                width: `${width}px`,
                height: `${height}px`,
                transform: `translate(${pad - bounds.x}px, ${pad - bounds.y}px) scale(1)`,
            },
            filter: (node) => !(node.classList && (
                node.classList.contains('automation-edge-plus-btn')
                || node.classList.contains('automation-edge-drop-zone')
                || node.classList.contains('node-actions-menu')
                || node.classList.contains('automation-insert-menu')
            )),
        };
        try {
            let dataUrl;
            try {
                dataUrl = await toPng(viewportEl, options);
            } catch (err) {
                // Remote webfont CSS can't always be inlined - retry without embedding fonts.
                dataUrl = await toPng(viewportEl, { ...options, skipFonts: true });
            }
            const a = document.createElement('a');
            const safeName = String(automation.name || 'automation').replace(/[^\w\- ]+/g, '').trim() || 'automation';
            a.href = dataUrl;
            a.download = `${safeName}.png`;
            a.click();
        } catch (err) {
            console.error('Export as image failed:', err);
            toast.error('Could not export the automation image');
        }
    };

    // Smoothly centre the canvas on one card (used to jump to the first card that failed a check).
    const focusNode = (nodeId) => {
        const n = nodes.find((x) => x.id === nodeId);
        if (!n || !rfInstance) return;
        setSelectedNodeId(null);
        rfInstance.setCenter(n.position.x + 110, n.position.y + 40, { zoom: 1, duration: 600 });
    };

    const handleDuplicate = async () => {
        setShowMoreMenu(false);
        const clone = await duplicateAutomationAction(appId, automation);
        if (clone) navigate(`/apps/${appId}/automations/${clone.id}`);
    };

    const handleDelete = async () => {
        setShowMoreMenu(false);
        const ok = await deleteAutomationAction(appId, automation);
        if (ok) navigate(`/apps/${appId}/automations`);
    };

    const handleOpenAuditLogs = async () => {
        setShowMoreMenu(false);
        setSelectedNodeId(null);
        setInsertMenu(null);
        setShowAuditModal(true);
        setAuditLoading(true);
        const data = await fetchAutomationAuditLogs(appId, automationId);
        setAuditLogs(data || []);
        setAuditLoading(false);
    };
    const handleNewAutomation = async () => {
        setShowMoreMenu(false);
        const created = await createAutomationAction(appId, 'New Automation');
        if (created) navigate(`/apps/${appId}/automations/${created.id}`);
    };

    const getDefaultNodeData = (type) => {
        switch (type) {
            case getAutomationNodeType('wait')?.value:
                return {
                    label: getAutomationNodeType('wait')?.label,
                    delay: 5,
                    unit: findOptionByValue(AUTOMATION_WAIT_UNIT_CODES, 1)?.value,
                    note: '',
                };

            case getAutomationNodeType('push')?.value:
                return {
                    label: getAutomationNodeType('push')?.label,
                    template: '',
                    template_id: '',
                    note: '',
                    goal_enabled: false,
                    goal_name: '',
                    goal_description: '',
                    goal_metric: '',
                };

            case getAutomationNodeType('condition')?.value:
                return {
                    label: getAutomationNodeType('condition')?.label,
                    conditionMode: 'event',
                    eventName: '',
                    messageBehaviorKey: '',
                    messageBehaviorLabel: '',
                    segmentIds: [],
                    note: '',
                };
            case getAutomationNodeType('whatsapp')?.value:
                return {
                    label: getAutomationNodeType('whatsapp')?.label,
                    template: '',
                    template_id: '',
                    template_variables: '',
                    note: '',
                    goal_enabled: false,
                    goal_name: '',
                    goal_description: '',
                    goal_metric: '',
                };

            case getAutomationNodeType('email')?.value:
                return {
                    label: getAutomationNodeType('email')?.label,
                    template: '',
                    note: '',
                    sender_name: '',
                    sender_email: '',
                    reply_to_email: '',
                    track_link_clicks: true,
                    include_unsubscribed: false,
                    goal_enabled: false,
                    goal_name: '',
                    goal_description: '',
                    goal_metric: '',
                };

            case getAutomationNodeType('in_app')?.value:
                return {
                    label: getAutomationNodeType('in_app')?.label,
                    template: ''
                };

            case getAutomationNodeType('sms')?.value:
                return {
                    label: getAutomationNodeType('sms')?.label,
                    template: ''
                };

            case getAutomationNodeType('tag')?.value:
                return {
                    label: getAutomationNodeType('tag')?.label,
                    tags: [],
                    note: '',
                };

            default:
                return {};
        }
    };

    const handleSelectNodeType = (nodeType) => {
        setInsertMenu((prev) => ({ ...prev, step: 'configure', nodeType, draftData: getDefaultNodeData(nodeType) }));
    };

    const handleConfirmInsert = () => {
        insertNodeOnEdge(insertMenu.edgeId, insertMenu.nodeType, insertMenu.draftData);
    };

    const updateDraftData = (key, value) => {
        setInsertMenu((prev) => ({ ...prev, draftData: { ...prev.draftData, [key]: value } }));
    };

    const handleBackToList = () => {
        setInsertMenu((prev) => ({ edgeId: prev.edgeId }));
    };

    // ---------------------------------------------------------------------------------------
    // Layout. The graph (edges) is the single source of truth; every position is recomputed
    // from it on any change, starting at the Entrance.
    //
    // A Condition is always an explicit block:  C --yes--> ...branch... --> J
    //                                            C --no-->  ...branch... --> J --> next
    // where J is that Condition's own (invisible) Join node. Laying a block out is recursive:
    //   width  = sum of its branch slot widths (+ gaps); a branch slot is as wide as the widest
    //            thing inside it (a plain card, or a nested block's own width) - so nested blocks
    //            on either side never overlap, at any depth;
    //   height = the LONGEST branch decides where J sits; shorter branches just get a longer
    //            straight line down to the same merge turn, so both sides always close level.
    // ---------------------------------------------------------------------------------------
    const NODE_GAP = 90; // card bottom -> next card top (the "+" sits in the middle)
    const NODE_FALLBACK_HEIGHT = 110; // until React Flow has measured the card
    const CARD_WIDTH = 220; // .automation-node width (App.css)
    const JOIN_SIZE = 2; // .automation-join-node width/height (App.css)
    const MIN_BRANCH_WIDTH = CARD_WIDTH + 40; // narrowest branch slot (a plain column of cards)
    const BRANCH_GAP_H = 60; // extra air between two sibling slots
    const CONDITION_BRANCH_GAP = 110; // Condition bottom -> first card of a branch (stem + label + "+")
    const EMPTY_BRANCH_HEIGHT = 120; // vertical room an all-empty block keeps for its branch "+"
    const TAIL_GAP = 120; // last card of a branch -> Join (its "+" and the merge turn)
    const AFTER_JOIN_GAP = NODE_GAP; // Join -> next card

    const nodeHeight = (n) => {
        if (n.type === JOIN_TYPE) return JOIN_SIZE;
        return n.measured?.height ?? NODE_FALLBACK_HEIGHT;
    };

    const computeLayout = (nds, eds) => {
        const entrance = nds.find((n) => n.type === ENTRANCE_TYPE);
        if (!entrance) return nds;
        const byId = {};
        nds.forEach((n) => { byId[n.id] = n; });
        const outMap = {};
        eds.forEach((e) => { (outMap[e.source] = outMap[e.source] || []).push(e); });
        const branchRank = (e) => (e.data?.branch === 'yes' ? 0 : e.data?.branch === 'no' ? 1 : 2);
        const outsOf = (id) => [...(outMap[id] || [])].sort((a, b) => branchRank(a) - branchRank(b));
        const joinOf = (condId) => findJoinOf(condId, byId, outMap);

        // Width a chain (from `id` up to, not including, `stopAt`) needs.
        const widthCache = {};
        const chainWidth = (id, stopAt) => {
            const key = `${id}|${stopAt}`;
            if (key in widthCache) return widthCache[key];
            widthCache[key] = MIN_BRANCH_WIDTH;
            let w = MIN_BRANCH_WIDTH;
            let cur = id;
            const seen = new Set();
            while (cur && cur !== stopAt && byId[cur] && !seen.has(cur)) {
                seen.add(cur);
                if (byId[cur].type === CONDITION_TYPE) {
                    const j = joinOf(cur);
                    w = Math.max(w, blockWidth(cur, j));
                    if (!j) break;
                    cur = outsOf(j)[0]?.target;
                    continue;
                }
                cur = outsOf(cur)[0]?.target;
            }
            widthCache[key] = w;
            return w;
        };
        const slotWidths = (condId, j) => outsOf(condId).map((e) => (e.target === j ? MIN_BRANCH_WIDTH : chainWidth(e.target, j)));
        const blockWidth = (condId, j) => {
            const ws = slotWidths(condId, j);
            return ws.reduce((a, b) => a + b, 0) + Math.max(ws.length - 1, 0) * BRANCH_GAP_H;
        };

        const positioned = {};
        const slots = {}; // condition id -> { yes: centerX, no: centerX }

        // Places the chain starting at `id` (centered on column `cx`, top at `y`) until `stopAt`.
        // Returns the bottom Y of the last thing placed, or null when nothing was placed.
        const placeChain = (id, y, cx, stopAt, seen = new Set()) => {
            let cur = id;
            let curY = y;
            let lastBottom = null;
            while (cur && cur !== stopAt && byId[cur] && !seen.has(cur)) {
                seen.add(cur);
                const node = byId[cur];
                const h = nodeHeight(node);
                positioned[cur] = { x: cx - (node.type === JOIN_TYPE ? JOIN_SIZE : CARD_WIDTH) / 2, y: curY };
                const bottom = curY + h;
                if (node.type === CONDITION_TYPE) {
                    const j = joinOf(cur);
                    const outs = outsOf(cur);
                    const ws = slotWidths(cur, j);
                    const total = ws.reduce((a, b) => a + b, 0) + Math.max(ws.length - 1, 0) * BRANCH_GAP_H;
                    const branchTop = bottom + CONDITION_BRANCH_GAP;
                    let left = cx - total / 2;
                    let maxBottom = null;
                    const blockSlots = {};
                    slots[cur] = blockSlots;
                    outs.forEach((e, i) => {
                        const center = left + ws[i] / 2;
                        blockSlots[e.data?.branch || `b${i}`] = center;
                        if (e.target !== j) {
                            const b = placeChain(e.target, branchTop, center, j, seen);
                            if (b !== null) maxBottom = maxBottom === null ? b : Math.max(maxBottom, b);
                        }
                        left += ws[i] + BRANCH_GAP_H;
                    });
                    if (!j || !byId[j]) return maxBottom ?? bottom; // malformed - stop here
                    const joinY = maxBottom === null
                        ? bottom + CONDITION_BRANCH_GAP + EMPTY_BRANCH_HEIGHT
                        : maxBottom + TAIL_GAP;
                    positioned[j] = { x: cx - JOIN_SIZE / 2, y: joinY };
                    seen.add(j);
                    lastBottom = joinY + JOIN_SIZE;
                    cur = outsOf(j)[0]?.target;
                    curY = lastBottom + AFTER_JOIN_GAP;
                    continue;
                }
                lastBottom = bottom;
                const next = outsOf(cur)[0]?.target;
                cur = next;
                curY = bottom + NODE_GAP;
            }
            return lastBottom;
        };

        const cx0 = (entrance.position?.x ?? 300) + CARD_WIDTH / 2;
        placeChain(entrance.id, 0, cx0, null);

        return nds.map((n) => {
            const pos = positioned[n.id];
            const branchSlots = slots[n.id];
            if (!pos && !branchSlots) return n;
            return { ...n, ...(pos ? { position: pos } : {}), ...(branchSlots ? { branchSlots } : {}) };
        });
    };

    const uid = () => `${Date.now()}${Math.random().toString(36).slice(2, 6)}`;
    const makeEdge = (source, target, extra = {}) => ({ id: `e_${source}_${target}_${uid()}`, source, target, ...extra });
    const makeJoinNode = (conditionId) => ({
        id: `join-${conditionId}`,
        type: JOIN_TYPE,
        position: { x: 0, y: 0 },
        data: { conditionId },
        draggable: false,
        selectable: false,
        focusable: false,
    });

    // New Condition placed on edge (src -> tgt): src -> C, C -yes-> J, C -no-> J, J -> tgt.
    const conditionBlockEdges = (condId, joinId, target) => [
        makeEdge(condId, joinId, { sourceHandle: 'out', data: { branch: 'yes' } }),
        makeEdge(condId, joinId, { sourceHandle: 'out', data: { branch: 'no' } }),
        makeEdge(joinId, target),
    ];

    const insertNodeOnEdge = (edgeId, nodeType, data) => {
        const edge = edges.find((e) => e.id === edgeId);
        if (!edge) return;
        const newId = `${nodeType}-${uid()}`;
        const newNode = {
            id: newId,
            type: nodeType,
            position: { x: 0, y: 0 }, // computeLayout overwrites
            data: data || getDefaultNodeData(nodeType),
            draggable: nodeType !== CONDITION_TYPE,
        };
        // The incoming side keeps the original edge's branch tag/handle (so a node dropped on a
        // Yes/No branch stays on that branch).
        let newEdges = [
            ...edges.filter((e) => e.id !== edgeId),
            makeEdge(edge.source, newId, { sourceHandle: edge.sourceHandle, data: edge.data }),
        ];
        const newNodes = [...nodes, newNode];
        if (nodeType === CONDITION_TYPE) {
            const join = makeJoinNode(newId);
            newNodes.push(join);
            newEdges = [...newEdges, ...conditionBlockEdges(newId, join.id, edge.target)];
        } else {
            newEdges.push(makeEdge(newId, edge.target));
        }
        setEdges(newEdges);
        setNodes(computeLayout(newNodes, newEdges));
        setInsertMenu(null);
    };

    // Takes a single-in/single-out node out of the flow and reconnects its neighbours.
    const detachNode = (eds, nodeId) => {
        const incoming = eds.filter((e) => e.target === nodeId);
        const outgoing = eds.filter((e) => e.source === nodeId);
        const remaining = eds.filter((e) => e.source !== nodeId && e.target !== nodeId);
        const bridges = [];
        incoming.forEach((inE) => {
            outgoing.forEach((outE) => {
                bridges.push(makeEdge(inE.source, outE.target, { sourceHandle: inE.sourceHandle, data: inE.data }));
            });
        });
        return [...remaining, ...bridges];
    };

    // Every node inside a Condition block (both branches, nested blocks included), plus its Join.
    const conditionBlockNodeIds = (condId, nds, eds) => {
        const byId = {};
        nds.forEach((n) => { byId[n.id] = n; });
        const outMap = {};
        eds.forEach((e) => { (outMap[e.source] = outMap[e.source] || []).push(e); });
        const j = findJoinOf(condId, byId, outMap);
        const ids = new Set([condId]);
        if (j) ids.add(j);
        const stack = (outMap[condId] || []).map((e) => e.target);
        while (stack.length) {
            const id = stack.pop();
            if (!id || ids.has(id) || id === j || !byId[id]) continue;
            ids.add(id);
            (outMap[id] || []).forEach((e) => stack.push(e.target));
        }
        return { ids, joinId: j };
    };

    const removeNode = (nodeId) => {
        const node = nodes.find((n) => n.id === nodeId);
        if (!node || node.type === ENTRANCE_TYPE || node.type === EXIT_TYPE || node.type === JOIN_TYPE) return;
        let newEdges;
        let newNodes;
        if (node.type === CONDITION_TYPE) {
            // Deleting a Condition removes its whole block (both branches + its Join) and
            // reconnects whatever came before it straight to whatever came after the Join.
            const { ids, joinId } = conditionBlockNodeIds(nodeId, nodes, edges);
            const incoming = edges.filter((e) => e.target === nodeId);
            const after = joinId ? edges.find((e) => e.source === joinId) : null;
            newEdges = edges.filter((e) => !ids.has(e.source) && !ids.has(e.target));
            if (after) {
                incoming.forEach((inE) => {
                    newEdges.push(makeEdge(inE.source, after.target, { sourceHandle: inE.sourceHandle, data: inE.data }));
                });
            }
            newNodes = nodes.filter((n) => !ids.has(n.id));
        } else {
            newEdges = detachNode(edges, nodeId);
            newNodes = nodes.filter((n) => n.id !== nodeId);
        }
        setEdges(newEdges);
        setNodes(computeLayout(newNodes, newEdges));
        setSelectedNodeId((cur) => (cur && !newNodes.some((n) => n.id === cur) ? null : cur));
    };

    const duplicateNode = (nodeId) => {
        const node = nodes.find((n) => n.id === nodeId);
        if (!node || node.type === ENTRANCE_TYPE || node.type === EXIT_TYPE || node.type === JOIN_TYPE) return;
        // A Condition's copy goes right after its whole block (after its Join), not inside a branch.
        let fromId = nodeId;
        if (node.type === CONDITION_TYPE) {
            const { joinId } = conditionBlockNodeIds(nodeId, nodes, edges);
            if (!joinId) return;
            fromId = joinId;
        }
        const outgoingEdge = edges.find((e) => e.source === fromId);
        if (!outgoingEdge) return;
        insertNodeOnEdge(outgoingEdge.id, node.type, JSON.parse(JSON.stringify(node.data || {})));
    };

    const editNode = (nodeId) => {
        const node = nodes.find((n) => n.id === nodeId);
        if (!node || node.type === JOIN_TYPE) return;
        if (node.type === ENTRANCE_TYPE || node.type === EXIT_TYPE) {
            setSelectedNodeId(null);
            setShowAutomationSettings(true);
            return;
        }
        setShowAutomationSettings(false);
        setSelectedNodeId(nodeId);
    };

    // Drag-drop reorder: card ko uthakar kisi bhi "+" (edge) ke paas le jao - us edge ka drop-zone
    // highlight ho jayega, aur chhodte hi vahi node us position pe move ho jata h (arrows apne aap
    // re-link ho jate h, koi edge dangling nahi rehti).
    const isFixedNode = (n) => [ENTRANCE_TYPE, EXIT_TYPE, CONDITION_TYPE, JOIN_TYPE].includes(n?.type);
    const handleNodeDragStart = (_, node) => {
        if (isFixedNode(node)) return;
        setInsertMenu(null);
        // Drag shuru hote hi uski original jagah pe ek clone (ghost) dikha do - upar-niche
        // ki edges isi ghost se reroute ho jati h (JSX me), taki arrow/plus bilkul normal
        // connected dikhte rahe. Asli node (jo cursor ke sath float karta h) edges se free
        // rehta h, isliye uski taraf koi line kheenchti hui nahi dikhegi.
        setDragState({
            nodeId: node.id,
            nodeType: node.type,
            nodeData: node.data,
            origin: { x: node.position.x, y: node.position.y },
            width: node.measured?.width ?? 220,
            height: node.measured?.height ?? NODE_FALLBACK_HEIGHT,
        });
    };

    // Drag ke dauran (aur drop par) "kahan sabse paas h" ab node-CENTER se doosre node-CENTERS
    // ki midpoint-distance se nahi nikalte - uski jagah seedha har "+" icon ki ASLI screen
    // position (getBoundingClientRect) se, mouse event ki clientX/clientY ke against - taaki card
    // ko theek us "+" button ke paas chhodne par hi wahi "+" target bane, chahe woh ek normal
    // edge ka "+" ho ya Condition ke merge ke baad wala (jiski koi asli single edge hi nahi hoti).
    const findNearestPlusId = (event, threshold = 60) => {
        if (!event || typeof event.clientX !== 'number') return null;
        const zones = document.querySelectorAll('.automation-edge-drop-zone[data-plus-id]');
        let nearestId = null;
        let nearestDist = threshold;
        zones.forEach((el) => {
            const rect = el.getBoundingClientRect();
            const cx = rect.left + rect.width / 2;
            const cy = rect.top + rect.height / 2;
            const dist = Math.hypot(event.clientX - cx, event.clientY - cy);
            if (dist < nearestDist) {
                nearestDist = dist;
                nearestId = el.getAttribute('data-plus-id');
            }
        });
        return nearestId;
    };

    const handleNodeDrag = (event, node) => {
        if (isFixedNode(node)) return;
        setDropTargetEdgeId(findNearestPlusId(event));
    };

    // Dragged node ko ek target "+" (normal edge wala ya merge-ke-baad wala) par jod deta h -
    // dono "insert on edge" aur "insert after merge" (upar wale insertNodeOnEdge/insertNodeAfterMerge
    // jesa hi) ka equivalent, bas naya node banane ki jagah EXISTING (drag ho raha) node use karta h.
    // Re-links an existing (dragged) node onto the edge of the "+" it was dropped on.
    const connectDroppedNode = (node, candidateEdges, plusId) => {
        const targetEdge = candidateEdges.find((e) => e.id === plusId);
        if (!targetEdge) return null;
        return [
            ...candidateEdges.filter((e) => e.id !== targetEdge.id),
            makeEdge(targetEdge.source, node.id, { sourceHandle: targetEdge.sourceHandle, data: targetEdge.data }),
            makeEdge(node.id, targetEdge.target),
        ];
    };

    const handleNodeDragStop = (event, node) => {
        setDragState(null);

        if (isFixedNode(node)) {
            setDropTargetEdgeId(null);
            return;
        }

        const candidateEdges = detachNode(edges, node.id);
        const targetPlusId = findNearestPlusId(event);
        const newEdges = targetPlusId ? connectDroppedNode(node, candidateEdges, targetPlusId) : null;

        if (!newEdges) {
            // Valid drop-zone nahi mila - graph order hi waisa rehta h, layout apne aap snap-back kar dega
            setDropTargetEdgeId(null);
            setNodes((nds) => computeLayout(nds, edges));
            return;
        }

        setEdges(newEdges);
        setNodes((nds) => computeLayout(nds, newEdges));
        setDropTargetEdgeId(null);
    };



    useEffect(() => {
        if (!insertMenu) return;
        const onClickOutside = (e) => {
            if (insertMenuRef.current && !insertMenuRef.current.contains(e.target)) setInsertMenu(null);
        };
        document.addEventListener('mousedown', onClickOutside);
        return () => document.removeEventListener('mousedown', onClickOutside);
    }, [insertMenu]);

    useEffect(() => {
        fetchWithAuth(Utils.baseurl + 'automations/get', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ app_id: appId, id: automationId }),
        })
            .then((r) => r.json())
            .then((result) => {
                if (!result.status) {
                    toast.error(result.message);
                    return;
                }

                const data = result.data;
                if (typeof data.graph === 'string') {
                    data.graph = JSON.parse(data.graph);
                }

                setAutomation(data);

                const rawNodes = data.graph?.nodes || [];
                const loadedEdges = data.graph?.edges || [];

                // Purane saved automations me condition node ka sirf ek (yes/no me se ek) hi
                // branch-edge ho sakta h - load hote hi dono branches guarantee kar do taaki
                // "+" button dono jagah dikhe aur dono aage jaake sahi node se mil jaye.
                const branchEdges = ensureConditionBranches(rawNodes, loadedEdges);
                // ...and every Condition gets its explicit Join (see ensureJoinNodes).
                const migrated = ensureJoinNodes(rawNodes, branchEdges);
                const fixedEdges = migrated.edges;
                const fixedTypes = [getAutomationNodeType('entrance')?.value, getAutomationNodeType('exit')?.value, CONDITION_TYPE, JOIN_TYPE];
                const loadedNodes = migrated.nodes.map((n) => ({
                    ...n,
                    draggable: !fixedTypes.includes(n.type),
                    ...(n.type === JOIN_TYPE ? { selectable: false, focusable: false } : {}),
                }));

                // Purane saved automations me position kisi bhi gap-logic se save hui ho sakti h -
                // load hote hi ek baar layout recompute kar do taki spacing hamesha consistent dikhe.
                const relaidNodes = computeLayout(loadedNodes, fixedEdges);
                setNodes(relaidNodes);
                setEdges(fixedEdges);
                savedGraphRef.current = normalizeGraphForDiff(relaidNodes, fixedEdges);

                if (data.graph?.viewport) {
                    setViewport(data.graph.viewport);
                }
            })
            .catch(() => {
                toast.error('Unable to load automation');
            })
            .finally(() => {
                setLoading(false)
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId, automationId]);

    useEffect(() => {
        if (!appId || !automationId) return;
        let cancelled = false;
        const refreshCounts = () => {
            fetchAutomationNodeCounts(appId, automationId).then((counts) => {
                if (!cancelled) setNodeCounts(counts || {});
            });
        };
        refreshCounts();
        const timer = setInterval(refreshCounts, 20000);
        return () => { cancelled = true; clearInterval(timer); };
    }, [appId, automationId]);

    const handleViewNodeUsers = (nodeId, label) => {
        setNodeUsersTarget({ id: nodeId, label: label || 'this step' });
        setNodeUsersPage(1);
        setShowNodeUsersModal(true);
    };

    const loadNodeUsersPage = (targetId, page) => {
        if (!targetId) return;
        setNodeUsersLoading(true);
        fetchAutomationNodeEnrollments(appId, automationId, targetId, { page, pageSize: 25 }).then((result) => {
            setNodeUsersResult(result);
            setNodeUsersLoading(false);
        });
    };

    useEffect(() => {
        if (!showNodeUsersModal || !nodeUsersTarget?.id) return;
        loadNodeUsersPage(nodeUsersTarget.id, nodeUsersPage);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showNodeUsersModal, nodeUsersTarget, nodeUsersPage]);


    const onNodesChange = useCallback((changes) => {
        setNodes((currentNodes) => {
            const filteredChanges = changes.filter((change) => {
                if (change.type !== 'remove') {
                    return true;
                }

                const node = currentNodes.find((item) => item.id === change.id);

                return node?.type !== getAutomationNodeType('entrance')?.value && node?.type !== getAutomationNodeType('exit')?.value;
            });
            return applyNodeChanges(filteredChanges, currentNodes);
        });
    }, []);

    const onEdgesChange = useCallback((changes) => {
        setEdges((currentEdges) => {
            return applyEdgeChanges(changes, currentEdges);
        });
    }, []);

    const onConnect = useCallback((connection) => {
        setEdges((currentEdges) =>
            addEdge(
                {
                    ...connection,
                    animated: true,
                },
                currentEdges
            )
        );
    }, []);

    // Naya/pehli-baar-render hone wala card shuru me NODE_FALLBACK_HEIGHT (estimate) se layout
    // hota h kyuki React Flow ne abhi tak uski ASLI height measure nahi ki hoti. Jaise hi React Flow
    // measure kar leta h (node.measured.height badalta h), ek baar layout dubara recompute kar dete h
    // taki arrow ki length turant sahi (exact) ho jaye - bina kisi infinite loop ke, kyuki position
    // sirf tabhi update hoti h jab vo sach me badli ho.
    const measuredHeightsKey = nodes.map((n) => `${n.id}:${n.measured?.height ?? ''}`).join('|');
    useEffect(() => {
        setNodes((nds) => {
            const relaid = computeLayout(nds, edges);
            const changed = relaid.some((n, i) => n.position.y !== nds[i]?.position.y || n.position.x !== nds[i]?.position.x
                || JSON.stringify(n.branchSlots || null) !== JSON.stringify(nds[i]?.branchSlots || null));
            return changed ? relaid : nds;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [measuredHeightsKey]);

    const handleNodeClick = (_, node) => {
        setInsertMenu(null);
        setShowAuditModal(false);
        setShowMoreMenu(false);
        editNode(node.id);
    };

    useEffect(() => {
        setSelectedNode(selectedNodeId ? nodes.find((n) => n.id === selectedNodeId) : null);
    }, [selectedNodeId, nodes]);

    useEffect(() => {
        if (loading || !automationId) return;
        const timer = setTimeout(() => {
            fetchWithAuth(Utils.baseurl + 'automations/validate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ app_id: appId, id: automationId, graph: serializeAutomationGraph({ nodes, edges, viewport }) }),
            })
                .then((r) => r.json())
                .then((result) => { if (result.status) setValidation(result.data); })
                .catch(() => { });
        }, 500);
        return () => clearTimeout(timer);
    }, [appId, automationId, loading, nodes, edges, viewport]);



    const handleSave = async ({ quiet } = {}) => {
        if (isReadOnlyAutomation) return true; // view-only (live/ended/archived) - nothing to persist
        setSaving(true);
        try {
            const response = await fetchWithAuth(Utils.baseurl + 'automations/save', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    app_id: appId,
                    id: automationId,
                    graph: serializeAutomationGraph({ nodes, edges, viewport }),
                }),
            });

            const result = await response.json();

            if (result.status) {
                if (!quiet) toast.success(result.message || 'Automation saved successfully');
                savedGraphRef.current = normalizeGraphForDiff(nodes, edges);
                return true;
            }
            toast.error(result.message || 'Unable to save automation');
            return false;
        } catch (error) {
            toast.error('Unable to save automation');
            return false;
        } finally {
            setSaving(false);
        }
    };

    const handleBackClick = async () => {
        if (isAutomationDirty()) {
            const ok = await confirmDiscardChanges();
            if (!ok) return;
        }
        navigate(`/apps/${appId}/automations`);
    };

    // Browser/tab refresh ya close pe bhi - agar automation graph me unsaved change h to native
    // "leave site?" warning dikhani h (humari apni Swal popup yahan kaam nahi karti, browser
    // ka hi built-in confirm hota h).
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (isAutomationDirty()) {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nodes, edges]);


    const handleSaveAutomationSettings = async (draft) => {
        const response = await fetchWithAuth(Utils.baseurl + 'automations/save', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ app_id: appId, id: automationId, ...draft }),
        });
        const result = await response.json();
        if (result.status) {
            toast.success(result.message || 'Settings saved');
            setAutomation(result.data);
            setShowAutomationSettings(false);
        } else {
            toast.error(result.message || 'Unable to save settings');
        }
    };

    const handleChangeAutomationStatus = async (nextStatus) => {
        const liveStatus = findOptionByValue(AUTOMATION_STATUS_CODES, 3)?.value;
        if (Number(nextStatus) === liveStatus) {
            const saved = await handleSave({ quiet: true });
            if (!saved) return false;
        }
        setSaving(true);
        let result = null;
        try {
            result = await changeAutomationStatusAction(appId, automationId, nextStatus);
            if (result?.data) setAutomation(result.data);
        } finally {
            setSaving(false);
        }
        return Boolean(result?.data);
    };

    // "Set Live" click opens a checklist modal instead of flipping status right away - the
    // flow is saved + re-validated fresh (not just the last debounced check) so the modal shows
    // exactly what would be checked, walking entrance -> ... -> exit with pass/fail per step.
    const handleOpenSetLiveModal = async () => {
        setShowSetLiveModal(true);
        setSetLiveChecking(true);
        setSetLiveResult(null);
        const saved = await handleSave({ quiet: true });
        if (!saved) {
            setSetLiveChecking(false);
            setSetLiveResult({ ok: false, checks: [{ ok: false, label: 'Save automation', detail: 'Could not save the automation — try again.' }] });
            return;
        }
        try {
            const res = await fetchWithAuth(Utils.baseurl + 'automations/validate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ app_id: appId, id: automationId }),
            });
            const result = await res.json();
            if (result.status) {
                setValidation(result.data);
                setSetLiveResult(result.data);
                if (!result.data.ok) {
                    // Jump to the TOP-most failing card (checks come back in flow order) and outline
                    // every failing card so it's obvious which ones need fixing.
                    setHighlightErrors(true);
                    const first = (result.data.checks || []).find((c) => !c.ok && c.nodeId);
                    if (first) setTimeout(() => focusNode(first.nodeId), 200);
                } else {
                    setHighlightErrors(false);
                }
            } else {
                setSetLiveResult({ ok: false, checks: [{ ok: false, label: 'Run pre-launch checks', detail: result.message || 'Could not run checks' }] });
            }
        } catch (error) {
            setSetLiveResult({ ok: false, checks: [{ ok: false, label: 'Run pre-launch checks', detail: 'Network error — try again' }] });
        } finally {
            setSetLiveChecking(false);
        }
    };

    const handleCloseSetLiveModal = () => {
        if (settingLive) return;
        setShowSetLiveModal(false);
        const first = (setLiveResult?.checks || []).find((c) => !c.ok && c.nodeId);
        if (first) setTimeout(() => focusNode(first.nodeId), 150);
    };

    // Clicking a failed row in the pre-launch modal jumps straight to that card.
    const handleFocusFailedNode = (nodeId) => {
        setShowSetLiveModal(false);
        setTimeout(() => focusNode(nodeId), 150);
    };

    const handleConfirmSetLive = async () => {
        setSettingLive(true);
        try {
            const liveStatus = findOptionByValue(AUTOMATION_STATUS_CODES, 3)?.value;
            const went_live = await handleChangeAutomationStatus(liveStatus);
            // Only close on success - agar status change fail hui (already toasted by
            // changeAutomationStatusAction) to modal khula rehne do taaki user dubara try kar sake,
            // "Going live..." pe hamesha ke liye atka na rahe.
            if (went_live) { setShowSetLiveModal(false); setHighlightErrors(false); }
        } finally {
            setSettingLive(false);
        }
    };

    if (loading) return <div style={{ padding: 24 }}>Loading...</div>;
    if (!automation) return <div style={{ padding: 24 }}>Automation not found</div>;

    // Per-edge drawing info for PlusEdge (see its comment): which of the four shapes it is, and
    // for an empty Yes/No branch, the column that branch occupies (from computeLayout's slots).
    const edgeMetaById = {};
    {
        const byIdNode = {};
        nodes.forEach((n) => { byIdNode[n.id] = n; });
        edges.forEach((e) => {
            const src = byIdNode[e.source];
            const tgt = byIdNode[e.target];
            const fromCondition = src?.type === CONDITION_TYPE && (e.data?.branch === 'yes' || e.data?.branch === 'no');
            const intoJoin = tgt?.type === JOIN_TYPE;
            let edgeKind = 'plain';
            if (fromCondition) edgeKind = intoJoin ? 'branchEmpty' : 'branch';
            else if (intoJoin) edgeKind = 'tail';
            edgeMetaById[e.id] = {
                edgeKind,
                intoJoin,
                branchX: fromCondition ? src.branchSlots?.[e.data.branch] : undefined,
            };
        });
    }

    const liveStatus = findOptionByValue(AUTOMATION_STATUS_CODES, 3)?.value;
    const pausedStatus = findOptionByValue(AUTOMATION_STATUS_CODES, 4)?.value;
    const isLive = Number(automation.status) === liveStatus;
    const statusValue = Number(automation.status);
    const isReadOnly = isReadOnlyAutomation;
    const isArchivedStatus = statusValue === findOptionByValue(AUTOMATION_STATUS_CODES, 6)?.value;
    const failingNodeIds = highlightErrors
        ? new Set((validation?.checks || []).filter((c) => !c.ok && c.nodeId).map((c) => c.nodeId))
        : new Set();

    return (
        <div className='automation-builder'>
            <div className='automation-header'>
                <div>
                    <h4 style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                        {automation.name}
                        <span className={findOptionByValue(AUTOMATION_STATUS_CODES, automation.status)?.badgeClass || 'badge rounded-pill bg-light-secondary'}>
                            {findOptionByValue(AUTOMATION_STATUS_CODES, automation.status)?.label || 'Draft'}
                        </span>
                    </h4>

                    {automation.description ? (
                        <span title={automation.description.length > 80 ? automation.description : undefined}>
                            {automation.description.length > 80 ? `${automation.description.slice(0, 80)}...` : automation.description}
                        </span>
                    ) : null}
                </div>
                <div>
                    <button
                        type="button"
                        className="add_app_btn_secondary btn_theme_secondary automation-back-btn"
                        title="Back to automations"
                        onClick={handleBackClick}
                    >
                        <MdArrowBack size={16} />
                    </button>
                    <Dropdown
                        className="automation-more-options"
                        show={showMoreMenu}
                        onToggle={(isOpen) => setShowMoreMenu(isOpen)}
                    >
                        <Dropdown.Toggle as="button" type="button" className="add_app_btn_secondary btn_theme_secondary" id="automation-more-options-toggle">
                            More options
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu-subscription">
                            <Dropdown.Item as="button" type="button" onClick={handleNewAutomation}>
                                <MdOutlineAddCircleOutline size={18} style={{ marginRight: '8px', flexShrink: 0 }} />
                                <span style={{ fontSize: '0.875rem' }}>New Automation</span>
                            </Dropdown.Item>
                            <Dropdown.Item as="button" type="button" onClick={handleDuplicate}>
                                <LuCopy size={18} style={{ marginRight: '8px', flexShrink: 0 }} />
                                <span style={{ fontSize: '0.875rem' }}>Duplicate</span>
                            </Dropdown.Item>
                            <Dropdown.Item as="button" type="button" onClick={() => { setShowMoreMenu(false); exportImage(); }}>
                                <MdOutlineFileDownload size={18} style={{ marginRight: '8px', flexShrink: 0 }} />
                                <span style={{ fontSize: '0.875rem' }}>Export as image</span>
                            </Dropdown.Item>
                            <Dropdown.Item as="button" type="button" onClick={handleOpenAuditLogs}>
                                <BsClockHistory size={18} style={{ marginRight: '8px', flexShrink: 0 }} />
                                <span style={{ fontSize: '0.875rem' }}>View audit logs</span>
                            </Dropdown.Item>
                            <Dropdown.Item as="button" type="button" className="delete-class" onClick={handleDelete}>
                                <MdDeleteOutline size={18} style={{ marginRight: '8px', flexShrink: 0 }} />
                                <span style={{ fontSize: '0.875rem' }}>Delete</span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <button className="add_app_btn_secondary btn_theme_secondary" onClick={() => setShowAutomationSettings(true)}>
                        <MdOutlineSettings size={16} style={{ marginRight: 6 }} /> {isReadOnly ? 'View settings' : 'Settings'}
                    </button>

                    {!isReadOnly && (
                        <>
                            <button
                                className="add_app_btn_secondary btn_theme_secondary"
                                onClick={() => handleSave()}
                                disabled={saving}
                            >
                                <MdOutlineSaveAlt size={16} style={{ marginRight: 6 }} />
                                {saving ? 'Saving...' : 'Save'}
                            </button>
                            <button
                                className="add_app_btn btn_theme_primary"
                                onClick={async () => { const ok = await handleSave(); if (ok) navigate(`/apps/${appId}/automations`); }}
                                disabled={saving}
                            >
                                {saving ? 'Saving...' : 'Save and Close'}
                            </button>
                        </>
                    )}

                    {isLive ? (
                        <button
                            className="add_app_btn_secondary btn_theme_orange"
                            disabled={saving}
                            title="Pause this automation"
                            onClick={() => handleChangeAutomationStatus(pausedStatus)}
                        >
                            <MdOutlineRemoveCircleOutline size={16} style={{ marginRight: 6 }} />
                            Pause
                        </button>
                    ) : isReadOnly ? null : (
                        <button
                            className="add_app_btn btn_theme_primary"
                            disabled={saving}
                            onClick={handleOpenSetLiveModal}
                        >
                            <MdOutlinePlayCircleOutline size={16} style={{ marginRight: 6 }} />
                            Set Live
                        </button>
                    )}
                </div>
            </div>

            {!validation.ok && Array.isArray(validation.errors) && validation.errors.length > 0 && (
                <div className="automation-live-errors">
                    {validation.errors.map((err, i) => (
                        <div key={i}>{err}</div>
                    ))}
                </div>
            )}

            {isReadOnly && (
                <div className="automation-readonly-banner">
                    <span>
                        {isLive
                            ? 'This automation is live, so its flow is locked to protect the users already inside it. Pause it to make changes, then Set Live again.'
                            : isArchivedStatus
                                ? 'This automation is archived and can no longer be edited. Duplicate it to reuse the flow.'
                                : 'This automation has ended and can no longer be edited. Duplicate it to reuse the flow.'}
                    </span>
                </div>
            )}

            <div className="automation-workspace">
                <AutomationBuilderContext.Provider value={{ readOnly: isReadOnly, insertMenu, insertMenuRef, onSelectType: handleSelectNodeType, onEditNode: editNode, onDuplicateNode: duplicateNode, onRemoveNode: removeNode, openActionsMenuId, setOpenActionsMenuId, nodeCounts, onViewNodeUsers: handleViewNodeUsers }}>

                    <div className="automation-canvas">
                        <ReactFlow
                            edgeTypes={{ default: PlusEdge }}
                            nodes={[
                                ...nodes.map((n) => ({
                                    ...n,
                                    // Jis card ka "..." menu khula h usey baaki cards se upar uthao,
                                    // warna dropdown kisi sibling/selected card ke peeche chhup jata h
                                    // (React Flow har node ka apna stacking-context banata h).
                                    zIndex: n.id === openActionsMenuId ? 1000 : undefined,
                                    className: failingNodeIds.has(n.id) ? 'automation-node-has-error' : undefined,
                                })),
                                // Drag ke dauran uski original jagah pe ek clone (ghost) - upar-niche
                                // ki edges isi se reroute hoti h (neeche), isliye flow bilkul normal dikhta h
                                ...(dragState ? [{
                                    id: '__drag-ghost__',
                                    type: 'dragGhost',
                                    position: dragState.origin,
                                    data: { width: dragState.width, height: dragState.height, nodeType: dragState.nodeType, nodeData: dragState.nodeData },
                                    draggable: false,
                                    selectable: false,
                                    connectable: false,
                                }] : []),
                            ]}
                            edges={edges.map(e => {
                                // Jo node drag ho raha h, uski edges ko (sirf render ke liye) ghost node
                                // se reroute kar do - isse upar-niche ka arrow/plus bilkul normal connected
                                // dikhta rehta h; asli dragged node edges se free rehta h (koi line uski
                                // taraf nahi khinchti), sirf uska card float karta hua dikhega.
                                const source = dragState && e.source === dragState.nodeId ? '__drag-ghost__' : e.source;
                                const target = dragState && e.target === dragState.nodeId ? '__drag-ghost__' : e.target;
                                return {
                                    ...e,
                                    source,
                                    target,
                                    data: { ...e.data, onAdd: handleOpenInsertMenu, dropTargetId: dropTargetEdgeId, dragInProgress: !!dragState, readOnly: isReadOnly, ...edgeMetaById[e.id] },
                                    markerEnd: { type: MarkerType.ArrowClosed, width: 16, height: 16, color: '#9ca3af' },
                                };
                            })}
                            nodeTypes={nodeTypes}
                            onNodesChange={onNodesChange}
                            onEdgesChange={onEdgesChange}
                            onConnect={onConnect}
                            onNodeClick={handleNodeClick}
                            onNodeDragStart={handleNodeDragStart}
                            onNodeDrag={handleNodeDrag}
                            onNodeDragStop={handleNodeDragStop}
                            onPaneClick={() => { setInsertMenu(null); setShowMoreMenu(false); setOpenActionsMenuId(null); }}
                            onMoveEnd={(_, newViewport) => setViewport(newViewport)}
                            {...(viewport.x !== 0 || viewport.y !== 0 || viewport.zoom !== 1
                                ? { defaultViewport: viewport }
                                : { fitView: true, fitViewOptions: { padding: 0.6, maxZoom: 1.5 } })}
                            onInit={setRfInstance}
                            nodesDraggable={!isReadOnly}
                            nodesConnectable={!isReadOnly}
                            deleteKeyCode={null}
                            elevateNodesOnSelect={false}
                            panOnScroll={true}
                            zoomOnScroll={false}
                            zoomOnPinch={true}
                            zoomActivationKeyCode="Meta"
                        >
                            <Background />
                            <MiniMap />
                            <Controls showInteractive={false} />
                        </ReactFlow>
                    </div>
                </AutomationBuilderContext.Provider>
                {selectedNode && (
                    <NodeConfigPanel
                        node={selectedNode}
                        setNodes={setNodes}
                        onClose={() => setSelectedNodeId(null)}
                        appId={appId}
                        allNodes={nodes}
                        readOnly={isReadOnly}
                    />
                )}

                <AutomationSettingsPanel
                    show={showAutomationSettings}
                    automation={automation}
                    appId={appId}
                    onClose={() => setShowAutomationSettings(false)}
                    onSave={handleSaveAutomationSettings}
                    readOnly={isReadOnly}
                />



                {insertMenu && insertMenu.step === 'configure' && (
                    <Drawer
                        show={true}
                        title={getNodeConfigTitle(insertMenu.nodeType)}
                        onClose={() => setInsertMenu(null)}
                        onSave={handleConfirmInsert}
                        isDirty={JSON.stringify(insertMenu.draftData) !== JSON.stringify(getDefaultNodeData(insertMenu.nodeType))}
                    >
                        <NodeConfigFields nodeType={insertMenu.nodeType} draft={insertMenu.draftData} update={updateDraftData} appId={appId} allNodes={nodes} />
                    </Drawer>
                )}

                <AutomationAuditLogsModal
                    show={showAuditModal}
                    automationName={automation.name}
                    logs={auditLogs}
                    loading={auditLoading}
                    onClose={() => { setShowAuditModal(false); setAuditLogs([]); }}
                />

                <AutomationNodeUsersModal
                    show={showNodeUsersModal}
                    nodeLabel={nodeUsersTarget?.label || ''}
                    result={nodeUsersResult}
                    loading={nodeUsersLoading}
                    page={nodeUsersPage}
                    onPageChange={setNodeUsersPage}
                    onClose={() => { setShowNodeUsersModal(false); setNodeUsersTarget(null); setNodeUsersResult(null); }}
                />

                <AutomationSetLiveModal
                    show={showSetLiveModal}
                    checking={setLiveChecking}
                    result={setLiveResult}
                    submitting={settingLive}
                    onClose={handleCloseSetLiveModal}
                    onConfirm={handleConfirmSetLive}
                    onFocusNode={handleFocusFailedNode}
                />

            </div>
        </div>
    );
};

export default AutomationBuilder;